<template>
  <div class="addCheckPage">
    <Row>
      <Col :xs="{span: 24}" :xl="{span: 7}" :xxl="{span: 7}" class="firstCol">
        <Card :class="{addHeight:!outpatient_inpatient? true : ''}">
          <Form>
            <FormItem label="检查单号" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="!(uploadImage.targetImageCenterId == currentCenterId)">
              <Input disabled v-model.trim="checkNumber">
                <Button slot="suffix" v-clipboard:copy="checkNumber" v-clipboard:success="copyCheckNumberSuccess" v-clipboard:error="copyCheckNumberError">复制单号</Button>
              </Input>
            </FormItem>
            <FormItem label="绑定单号" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="uploadImage.targetImageCenterId == currentCenterId">
              <Input v-model.trim="bind_check_order_code">
                <Button slot="suffix" @click="asyncPatientInfo">同步信息</Button>
              </Input>
            </FormItem>
            <FormItem label="身份证号" :label-col="labelCol" :wrapper-col="wrapperCol">
              <Input :disabled="isEditedOperation" placeholder="请输入身份证号" v-model.trim="patientIdNumber" >
                <Button :disabled="isEditedOperation" slot="suffix" @click="handleIdNumber">读取</Button>
              </Input>
            </FormItem>
            <FormItem label="身份证地址" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="!(uploadImage.targetImageCenterId == currentCenterId)">
              <Input :disabled="isEditedOperation" placeholder="身份证地址" :maxLength="300" v-model.trim="cardAddress"></Input>
            </FormItem>
            <FormItem label="电话" :label-col="labelCol" :wrapper-col="wrapperCol" :required="uploadImage.targetImageCenterId == currentCenterId">
              <Input :disabled="isEditedOperation" placeholder="请输入电话" :maxLength="50" v-model.trim="patientMobile">
                <Button :disabled="isEditedOperation" slot="suffix" @click="getPatientInfo">读取</Button>
              </Input>
            </FormItem>
            <FormItem label="姓名" :label-col="labelCol" :wrapper-col="wrapperCol" required>
              <Input :disabled="isEditedOperation" placeholder="请输入姓名" :maxLength="50" v-model.trim="patientName"></Input>
            </FormItem>
            <FormItem label="性别" :label-col="labelCol" :wrapper-col="wrapperCol" required>
              <RadioGroup :disabled="isEditedOperation" v-model="patientGender">
                <RadioButton value="1">男</RadioButton>
                <RadioButton value="2">女</RadioButton>
                <RadioButton value="0">未知</RadioButton>
              </RadioGroup>
            </FormItem>
            <FormItem label="生日" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="uploadImage.targetImageCenterId != currentCenterId">
              <DatePicker :disabled="isEditedOperation" :getCalendarContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" style="width: 100%" v-model="patientBirthDay" @change="changeBirthday" :disabledDate="disabledDate"></DatePicker>
            </FormItem>
            <FormItem label="年龄" :label-col="labelCol" :wrapper-col="wrapperCol" required>
              <Input :disabled="isEditedOperation" placeholder="请输入年龄" v-model.trim="patientAge" type="number" :min="0">
                <Select :disabled="isEditedOperation" :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" slot="addonAfter" :defaultValue="50" v-model="ageUnit">
                  <SelectOption :value="50">岁</SelectOption>
                  <SelectOption :value="30">个月</SelectOption>
                  <SelectOption :value="20">周</SelectOption>
                  <SelectOption :value="10">日</SelectOption>
                </Select>
              </Input>
            </FormItem>
            <FormItem label="身高" type="number" :label-col="labelCol" :wrapper-col="wrapperCol">
              <Input :disabled="isEditedOperation" type="number" placeholder="请输入身高" :maxLength="50" v-model.trim="patientHeight" addonAfter="cm"></Input>
            </FormItem>
            <FormItem label="体重" :label-col="labelCol" :wrapper-col="wrapperCol">
              <Input :disabled="isEditedOperation" type="number" placeholder="请输入体重" :maxLength="50" v-model.trim="patientWeight" addonAfter="kg"></Input>
            </FormItem>
            <FormItem label="血压" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="uploadImage.targetImageCenterId == currentCenterId">
              <Input :disabled="isEditedOperation" placeholder="请输入血压" :maxLength="50" v-model.trim="blood_pressure"></Input>
            </FormItem>
            <FormItem label="既往病史" :label-col="labelCol" :wrapper-col="wrapperCol">
              <TextArea :disabled="isEditedOperation" placeholder="请输入既往病史" :autoSize="{ minRows: 1, maxRows: 2 }" :maxLength="100" v-model.trim="anamnesis"></TextArea>
            </FormItem>
            <FormItem label="患者来源" :label-col="labelCol" :wrapper-col="wrapperCol" :required="uploadImage.targetImageCenterId == currentCenterId">
              <Row>
                <Col :xs="{span: 6}" :md="{span: 4}" :xl="{span: 6}" >
                  <Select class="patientOriginSelect" :disabled="editMacthFlag || isEditedOperation || orderWaitEditStatus || isReceiptSuccess || isAppointmentCheck || isInHospitalCheckFlag || kzOrderFlag" :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model="orderSource" @change="changeOrderSource">
                    <SelectOption value="线下">线下</SelectOption>
                    <SelectOption value="快诊" v-if="from === 'addKzFlag' || from === 'editKzFlag' || from === 'callNum' || from === 'queue' ">快诊</SelectOption>
                    <SelectOption value="院内患者">院内患者</SelectOption>
                    <SelectOption value="医院体检">医院体检</SelectOption>
                    <SelectOption value="内部福利单">内部福利单</SelectOption>
                    <SelectOption value="外部福利单">外部福利单</SelectOption>
                    <SelectOption value="科研检查单">科研检查单</SelectOption>
                  </Select>
                </Col>
              </Row>
            </FormItem>
            <FormItem label="门诊/住院" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="uploadImage.targetImageCenterId != currentCenterId">
              <RadioGroup :disabled="isEditedOperation" v-model="outpatient_inpatient">
                <RadioButton :value="true">门诊</RadioButton>
                <RadioButton :value="false">住院</RadioButton>
              </RadioGroup>
            </FormItem>
            <FormItem label="住院号" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="!outpatient_inpatient">
              <Input :disabled="isEditedOperation" placeholder="请输入住院号" v-model.trim="admissionNumber"></Input>
            </FormItem>
            <FormItem label="床位" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="!outpatient_inpatient">
              <Input :disabled="isEditedOperation" placeholder="请输入床位" v-model.trim="hospitalBed"></Input>
            </FormItem>
            <FormItem label="是否急诊" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="uploadImage.targetImageCenterId != currentCenterId">
              <RadioGroup :disabled="isEditedOperation" v-model="emergency">
                <RadioButton :value="false">否</RadioButton>
                <RadioButton :value="true">是</RadioButton>
              </RadioGroup>
            </FormItem>
            <FormItem label="医保类型" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="uploadImage.targetImageCenterId != currentCenterId">
              <RadioGroup :disabled="isEditedOperation" v-model="medical_insurance">
                <RadioButton :value="false">自费</RadioButton>
                <RadioButton :value="true">医保</RadioButton>
              </RadioGroup>
            </FormItem>
          </Form>
        </Card>
      </Col>
      <Col :xs="24" :xl="17" :xxl="17" class="bodyInfoWrap">
        <Card :class="{addHeight:!outpatient_inpatient? true : ''}">
          <div class="deviceWrap">
            <Form layout="inline">
              <FormItem label="检查医院" v-if="!(uploadImage.targetImageCenterId == currentCenterId)">
                <Select :disabled="isEditedOperation || changeImageCenter || isNurseEditFlag || isSetllmentStatus || isFromCallNumPage" :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model="setCurrentHospitalVal" @change="changeCurrentHospital" style="width:120px">
                  <SelectOption v-for="(item) in centerVos" :key="item.id" :value="item.id">{{item.name || ''}}</SelectOption>
                </Select>
              </FormItem>
              <FormItem label="检查设备" v-if="!(uploadImage.targetImageCenterId == currentCenterId)">
                <Select :disabled="isEditedOperation || changeImageCenter || isNurseEditFlag || isSetllmentStatus || isFromCallNumPage" :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model="setCurDeviceVal" @change="changeCurDevice" style="width:70px">
                  <SelectOption v-for="(item) in deviceList" :key="item.id" :value="item.id">{{item.name || ''}}</SelectOption>
                </Select>
              </FormItem>
              <FormItem label="搜索部位" v-if="!(uploadImage.targetImageCenterId == currentCenterId)">
                <Input v-model.trim="searchBodyName" @change="changeCheckObject" :maxLength="10" :disabled="judgeIsEidtCheckOrder()" style="width:80px" allowClear></Input>
              </FormItem>
              <FormItem label="折算系数" v-if="!(uploadImage.targetImageCenterId == currentCenterId)">
                <Input v-model.trim="equivalentCount" type="number" disabled :min="0" :step="0.5" style="width:60px"></Input>
              </FormItem>
              <FormItem label="AI算法">
                <Button @click="choiceAfterDeal" class="afterDealClass" :disabled="judgeIsEidtCheckOrder()">{{afterHandleList.length === 0 ? '选择': afterDealTag}}</Button>
              </FormItem>
            </Form>
          </div>
          <div class="checkObject">
            <Form layout="inline">
              <FormItem label="检查分类">
                <RadioGroup v-model="checkObjectVal" @change="changeCheckObject" :disabled="judgeIsEidtCheckOrder()" style="display: inherit;">
                  <RadioButton v-for="(item, index) in checkObjectList" :key="index" :value="item.body_id">{{item.body_name}}</RadioButton>
                  <RadioButton value="特色检查" v-if="uploadImage.targetImageCenterId != currentCenterId">特色检查</RadioButton>
                </RadioGroup>
              </FormItem>
            </Form>
          </div>
          <div class="checkItemWrap" >
            <Row>
              <Col :span="16">
                <div class="choiceItem choiceItemleft">
                  <Button :disabled="judgeIsEidtCheckOrder()" v-for="(item, index) in checkBodyList" :key="index" style="margin-left:5px;margin-top:5px;" @click="handleClickCheckBody(item, index)" :type="item.checked ? 'primary' : ''">{{item.alias || item.body_item_name}}</Button>
                </div>
              </Col>
              <Col :span="8" v-if="!(uploadImage.targetImageCenterId == currentCenterId)">
                <div class="choiceItem handeleInputStyle">
                  <Table :columns="bodyCheckedList" :dataSource="checkedBodyData" rowKey="id" size="small" :pagination="false" :showHeader="false">
                    <template slot="bodyName" slot-scope="text, record" >
                      <div class="bodyItemName">
                        <a>{{record.body_item_name || record.name}}</a>
                      </div>
                    </template>
                    <template slot="bodyNum" slot-scope="text, record">
                      <InputNumber :disabled="judgeIsEidtCheckOrder() || (paymentStatus === 20 && (chargeChannel==='线上-微信' || chargeChannel==='线上-支付宝'))" :min="1" :max="10" v-model="record.bodyNum" @change="itemBodyNum(record)"></InputNumber>
                    </template>
                    <template slot="handleBody" slot-scope="text, record">
                      <div style="width:30px">
                        <a @click="removeCheckBody(record)" :disabled="judgeIsEidtCheckOrder() || (paymentStatus === 20 && (chargeChannel==='线上-微信' || chargeChannel==='线上-支付宝'))">删除</a>
                      </div>
                    </template>
                  </Table>
                </div>
              </Col>
            </Row>
          </div>
          <div class="consumablesWrap" >
            <Row>
              <Col :span="16">
                <div class="consumablesTable" v-if="!(uploadImage.targetImageCenterId == currentCenterId)">
                  <Table :dataSource="tableData" size="small" :pagination="false" :rowKey="() => Math.random() * 100 + new Date().valueOf()" bordered>
                    <TableColumn title="名称" dataIndex="materialName" width="30%">
                      <template slot-scope="text, record" >
                        <span v-if="record.type === 'base'">{{record.materialName}}扫描费用</span>
                        <Select v-else :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model="record.materialId" :disabled="checkOrderStatus === 50 || isEditedOperation || isReceiptSuccess || isAppointmentCheck || (paymentStatus === 20 && (chargeChannel==='线上-微信' || chargeChannel==='线上-支付宝'))" @change="handleChangeData(record)" style="width: 180px; margin-left: 12px;">
                          <SelectOption v-for="(item, index) in consumData" :key="index" :value="item.id">{{item.material_name}} ({{item.manufacter}})</SelectOption>
                        </Select>
                      </template>
                    </TableColumn>
                    <TableColumn title="数量" dataIndex="count" width="15%">
                      <template slot-scope="text, record" >
                        <InputNumber v-model="record.count" :disabled="(record.type === 'base') || judgeIsEidtCheckOrder() || isReceiptSuccess|| isAppointmentCheck || (paymentStatus === 20 && (chargeChannel==='线上-微信' || chargeChannel==='线上-支付宝'))" @change="changeMaterialCount(record)" :min="1"></InputNumber>
                      </template>
                    </TableColumn>
                    <TableColumn title="单价" dataIndex="materialPrice" width="15%"></TableColumn>
                    <TableColumn title="金额" dataIndex="materialAmount" width="15%">
                      <template slot-scope="text, record" >
                        <span>{{record.materialAmount}}</span>
                      </template>
                    </TableColumn>
                    <TableColumn title="操作" width="20%">
                      <template slot-scope="text, record, index" >
                        <Button size="small" @click="removeConsum(record)" v-if="record.type === 'material'" :disabled="judgeIsEidtCheckOrder() || isReceiptSuccess || isAppointmentCheck || (paymentStatus === 20 && (chargeChannel==='线上-微信' || chargeChannel==='线上-支付宝'))">删除</Button>
                        <Button size="small" @click="addNewConsum(record, index)" v-if="record.type === 'base'" :disabled="judgeIsEidtCheckOrder() || isReceiptSuccess || isAppointmentCheck || (paymentStatus === 20 && (chargeChannel==='线上-微信' || chargeChannel==='线上-支付宝'))">新增耗材</Button>
                      </template>
                    </TableColumn>
                  </Table>
                </div>
                <div class="remarksCon">
                  <div class="doctorNote" v-if="!(uploadImage.targetImageCenterId == currentCenterId)">
                    <p class="remarksTitle">备注</p>
                    <TextArea disabled class="remarksMsg" placeholder="请输入备注" :autoSize="{ minRows: 2, maxRows: 2 }" :maxLength="300" v-model.trim="remark.doctor"></TextArea>
                  </div>
                  <div class="operationNote" v-if="from === 'addKzFlag' || from === 'editKzFlag' || isEditedOperation || isAppointmentCheck">
                    <p class="remarksTitle">运营备注</p>
                    <TextArea :disabled="isEditedOperation" class="remarksMsg" placeholder="请输入备注" :autoSize="{ minRows: 2, maxRows: 2 }" :maxLength="300" v-model.trim="remark.operation"></TextArea>
                  </div>
                  <div class="operationNote" v-else>
                    <p class="remarksTitle">{{uploadImage.targetImageCenterId == currentCenterId? '备注': '护士备注'}}</p>
                    <TextArea class="remarksMsg" placeholder="请输入备注" :autoSize="{ minRows: 2, maxRows: 2 }" :maxLength="300" v-model.trim="remark.nurse"></TextArea>
                  </div>
                </div>
              </Col>
              <Col :span="8">
                <div class="choiceItem">
                  <Form>
                    <FormItem label="医疗费用" :label-col="labelColAnthor" :wrapper-col="wrapperColAnthor">
                      <Input disabled v-model="amount"></Input>
                    </FormItem>
                    <FormItem label="实际费用" :label-col="labelColAnthor" :wrapper-col="wrapperColAnthor">
                      <Row>
                        <Col :xs="{span: 14}" :md="{span: 18}" :xl="{span: 14}" >
                          <Input v-model="actualAmount" disabled ></Input>
                        </Col>
                        <Col :xs="{span: 10}" :md="{span: 6}" :xl="{span: 10}">
                          <Button type="primary" class="matchButtonWrap" @click="handleChangePirce" :disabled="idOrderPayedFlag || isAppointmentCheck || ['内部福利单', '外部福利单', '科研检查单'].includes(orderSource)">修改</Button>
                        </Col>
                      </Row>
                    </FormItem>
                    <FormItem label="收费渠道" :label-col="labelColAnthor" :wrapper-col="wrapperColAnthor">
                      <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" :defaultValue="''" v-model="chargeChannel" :disabled="isSetllmentStatus || editPriceFlag || isEditedOperation || orderWaitEditStatus || isReceiptSuccess || isAppointmentCheck || isFromCallNumPage || idOrderPayedFlag">
                        <SelectOption value="">请选择收费渠道</SelectOption>
                        <SelectOption value="线下-HIS">线下-HIS</SelectOption>
                        <SelectOption value="线上-微信">线上-微信</SelectOption>
                        <SelectOption value="线上-支付宝">线上-支付宝</SelectOption>
                        <SelectOption value="线下-POS机银行卡">线下-POS机银行卡</SelectOption>
                        <SelectOption value="线下-POS机微信">线下-POS机微信</SelectOption>
                        <SelectOption value="线下-POS机支付宝">线下-POS机支付宝</SelectOption>
                        <SelectOption value="线下-现金">线下-现金</SelectOption>
                      </Select>
                    </FormItem>
                    <FormItem label="预约时间" :label-col="labelColAnthor" :wrapper-col="wrapperColAnthor" v-if="uploadImage.targetImageCenterId != currentCenterId">
                      <Button type="primary" style="width: 100%" @click="checkDateTime" :disabled="editDateFlag || isEditedOperation">{{checkText}}</Button>
                    </FormItem>
                    <FormItem label="相关资料" :label-col="labelColAnthor" :wrapper-col="wrapperColAnthor" v-if="uploadImage.targetImageCenterId != currentCenterId">
                      <Button :disabled="isEditedOperation || orderWaitEditStatus || isReceiptSuccess || isAppointmentCheck" style="width: 100%" @click="shootingMaterial('addCheck')">{{relInformation.fileList.length > 0 ? '已拍摄':'拍摄'}}</Button>
                    </FormItem>
                    <FormItem label="是否需要报告" :label-col="labelColAnthor" :wrapper-col="wrapperColAnthor" v-if="isShowReport" :class="{aiHiddenItem: uploadImage.targetImageCenterId == currentCenterId? 'aiHiddenItem': ''}">
                      <RadioGroup v-model="report_required" :disabled="isNeedReportEditFlag">
                        <RadioButton :value="true">是</RadioButton>
                        <RadioButton :value="false">否</RadioButton>
                      </RadioGroup>
                    </FormItem>
                    <FormItem label="不分成订单" :label-col="labelColAnthor" :wrapper-col="wrapperColAnthor" v-if="isShowReport" :class="{aiHiddenItem: uploadImage.targetImageCenterId == currentCenterId? 'aiHiddenItem': ''}">
                      <RadioGroup v-model="charge_share_type">
                        <RadioButton :value="0">否</RadioButton>
                        <RadioButton :value="1">是</RadioButton>
                      </RadioGroup>
                    </FormItem>
                  </Form>
                </div>
              </Col>
            </Row>
          </div>
        </Card>
      </Col>
    </Row>
    <div class="buttonWrap">
      <Button type="primary" class="saveBtn" size="large" :disabled="setllmentStatue != 0"  @click="saveOrderAndSendMsg" :loading="submitLoading">保存</Button>
      <Button style="margin-right:16px;" class="cancelBtn" @click="handleRemove" size="large">取消</Button>
      <Button v-if="paymentStatus == 20 && uploadImage.targetImageCenterId == currentCenterId" style="margin-right:16px;" class="cancelBtn" @click="openUploadImageModal" size="large">上传影像</Button>
      <Button v-if="paymentStatus == 20 && uploadImage.targetImageCenterId == currentCenterId" style="margin-right:16px;" class="cancelBtn" @click="openUploadOtherModal" size="large">上传其他文件</Button>
      <div class="operationControl">
        <Button v-if="showWaitFlag" style="margin-right: 16px;" :disabled="isEditedOperation" type="default" size="large" @click="signWaitClick">标为待定订单</Button>
        <Button v-if="showWaitFlag" :disabled="isEditedOperation" type="default" size="large" @click="cancelOrderClick">取消订单</Button>
        <Button v-if="cancelOrder.showCancelBtn" :disabled="isEditedOperation" type="default" size="large" @click="cancelOrderClick">取消订单</Button>
        <Button v-if="showWaitFlag || cancelOrder.showCancelBtn" style="margin-left: 16px;" type="default" size="large" @click="handleCopyInfo">复制信息</Button>
      </div>
    </div>
    <!-- 选择检查时间 -->
    <Modal v-model="showCheckDate" title="选择预约时间" :width="678" :footer="null" :forceRender="false" class="checkTimeModal">
      <checkDate ref="check" @getCheckDate="getCheckDate" @closeCheckModal="closeCheckModal"></checkDate>
    </Modal>
    <!-- 匹配线下医生 -->
    <Modal v-model="showMatchDoctorModal" title="匹配" :width="960" :footer="null" :forceRender="false">
      <matchDoctorList v-if="showMatchDoctorModal" :matchDoctorId="doctorId" @closeMatchDoctor="() => (showMatchDoctorModal = false) " @noDoctorMate="noDoctorMate" @haveDoctorMate="haveDoctorMate"></matchDoctorList>
    </Modal>
    <!-- 匹配快诊订单 -->
    <Modal v-model="showMatchOrderList" title="匹配快诊订单" :width="960" :footer="null" :forceRender="false">
      <matchOrderList v-if="showMatchOrderList" :matchOrderCode="orderCode" @closeOrderMatch="() => (showMatchOrderList = false )" @noOrderMate="noOrderMate" @haveOrderMate="haveOrderMate"></matchOrderList>
    </Modal>
    <!-- 选择后处理标签 -->
    <Modal v-model="showAfterDealList"  v-if="showAfterDealList" title="AI算法" :width="682" :footer="null" class="afterDealModal">
      <afterDeal :dealTag="afterHandleList" @closeAfterDeal="closeAfterDeal" @newAddAfterDeal="newAddAfterDeal"></afterDeal>
    </Modal>
    <!-- 相关资料上传 -->
    <Modal title="相关资料" v-model="relInformation.openFlag" @cancel="closeRelInformation" :width="800">
      <div class="uploadWrap">
        <div class="showWrap">
          <div>
            <img class="showArea" id="bigPriDev"/>
          </div>
          <div class="operatonWrap">
            <Button size="large" type="primary" :loading="relInformation.generateLoading" @click="takePhoto">{{relInformation.generateLoading?'生成照片中':'拍照'}}</Button>
            <Upload :beforeUpload="(file) => { addImageBefore(file); return false;}" :multiple="true" :showUploadList="false">
              <Button size="large" type="primary" :loading="relInformation.generateLoading" @click="takePhoto" style="margin-left: 16px;">
                <Icon type="upload" />
                <span>上传照片</span>
              </Button>
            </Upload>
          </div>
        </div>
        <div class="imageList">
          <div class="imageItem" v-for="(item, index) in relInformation.fileList" :key="index" style="">
            <img :src="item.url"/>
            <div class="actionWrap">
              <div @click="previewImage(item)"><Icon type="eye" style="font-size:16px;cursor:pointer;"></Icon></div>
              <div style="margin:0 10px;" @click="downLoadImage(item)"><Icon type="download" style="font-size:16px;cursor:pointer;"></Icon></div>
              <div @click="deleteImage(item, index)"><Icon type="delete" style="font-size:16px;cursor:pointer;"></Icon></div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="closeRelInformation" >取消</Button>
        <Button type="primary" size="large" :loading="relInformation.saveBtnLoading" @click="uploadRelInformation('addCheck')">保存</Button>
      </div>
    </Modal>
    <!-- 图片预览 -->
    <Modal title="图片预览" :footer="null" v-model="relInformation.imagePreview" :width="800" v-if="relInformation.imagePreview">
      <img v-if='relInformation.previewUrl' :src="relInformation.previewUrl" style="width:100%;"/>
    </Modal>
    <!-- 标为问题订单弹框 -->
    <Modal title="订单标为待定" v-model="signWaitOrder.openFlag" v-if="signWaitOrder.openFlag" @ok="sureSignWaitOrder">
      <h3>请选择待定原因：</h3>
      <RadioGroup v-model="signWaitOrder.reason">
        <Radio :style="{ display: 'block',height: '30px',lineHeight: '30px',position: 'relative'}" v-for="val in signWaitOrder.reasonList" :key="val.key" :value="val.label" :name="val.label">
          {{val.label}}
          <TextArea style="position: absolute; top: 5px; left: 30%;margin-bottom: 20px;" v-if="val.key === 6" placeholder="请填写待定原因" :autosize="{ minRows: 2, maxRows: 2 }" :maxLength="30" v-model.trim="signWaitOrder.otherReasonMsg"></TextArea>
        </Radio>
      </RadioGroup>
      <p style="padding-top: 40px;">注：标记待定后，待定原因将发送给医生</p>
    </Modal>
    <!-- 取消订单 -->
    <Modal title="取消待定" v-model="cancelOrder.openFlag" v-if="cancelOrder.openFlag" @ok="sureCancelOrder">
      <p>确定取消 {{patientName}} 的订单？</p>
    </Modal>
    <!-- 发送短信 -->
    <Modal title="编辑短信" v-model="sendMsg.openFlag" v-if="sendMsg.openFlag" okText="发送"  @ok="sureSendMsg" :confirmLoading="sureSendMsgLoading" @cancel="cancelSendMsg">
      <div class="sendMsgModal">
        <p>短信内容：</p>
        <p>
          <editDiv v-model="msgInfo.patient_name" :textVal="msgInfo.patient_name" @inputDiv="handlePatientName"></editDiv>
          您好，
          <editDiv v-model="msgInfo.hospital_name" :textVal="msgInfo.hospital_name" @inputDiv="handleHospitalName"></editDiv>
          帮您安排了
          <editDiv v-model="msgInfo.body_names" :textVal="msgInfo.body_names" @inputDiv="handleBodyNames"></editDiv>
          ，请于
          <editDiv v-model="msgInfo.month" :textVal="msgInfo.month" @inputDiv="handleMonth"></editDiv>
          月
          <editDiv v-model="msgInfo.day" :textVal="msgInfo.day" @inputDiv="handleDay"></editDiv>
          日
          <editDiv v-model="msgInfo.time" :textVal="msgInfo.time" @inputDiv="handleTime"></editDiv>
          到医院办好手续等待检查，地址：
          <editDiv v-model="msgInfo.hospital_address" :textVal="msgInfo.hospital_address" @inputDiv="handleHospitalAddress"></editDiv>
          ;来院路线：
          <editDiv v-model="msgInfo.hospital_route" :textVal="msgInfo.hospital_route" @inputDiv="handleHospitalRoute"></editDiv>
          , 如有疑问请致电
          <editDiv v-model="msgInfo.patient_mobile" :textVal="msgInfo.patient_mobile" @inputDiv="handleTongxinMobile"></editDiv>
          ，祝早日康复
        </p>
      </div>
    </Modal>
    <!-- 复制信息 -->
    <Modal title="复制信息" v-model="showCopyInfo" v-if="showCopyInfo">
      <TextArea v-html="copyInfo" :rows="8"></TextArea>
      <div slot="footer">
        <Button size="large" @click="closeCopyInfo" >取消</Button>
        <Button type="primary" size="large" v-clipboard:copy="copyInfo" v-clipboard:success="handleOnCopy">复制</Button>
      </div>
    </Modal>
    <!-- 查看更多线上报到患者 -->
    <Modal v-model="showMoreOnlinePatient"  v-if="showMoreOnlinePatient" title="更多患者" :footer="null" :width="900">
      <onlineCheck @closeOnlinePatientModal="closeOnlinePatientModal" @handleSureMatch="handleSureMatch" :currentCenterId="currentCenterId"></onlineCheck>
    </Modal>
    <!-- 未匹配患者 -->
    <Modal title="未匹配患者" v-model="noMatchPatient" v-if="noMatchPatient" @ok="sureMatchPatient" :width="700">
      <h2 style="color:red;font-size:18px;">未匹配患者的检查订单，</h2>
      <h2 style="color:red;font-size:18px;">患者将永远不可查看该检查单的电子影像和报告，</h2>
      <h2 style="color:red;font-size:18px;">请谨慎选择</h2>
      <p>注：临床医生不受影像，在快诊公众号和网页版都可查看该患者的电子影像和报告</p>
    </Modal>
    <!-- 实际费用修改记录 -->
    <Modal v-model="editPriceRecord.showModal"  v-if="editPriceRecord.showModal" :zIndex="1000" title="修改记录" width="40%">
      <Table :columns="editPriceRecord.columns" :dataSource="editPriceRecord.list" border rowKey="id" :pagination="false">
        <template slot="control" slot-scope="text, record">
          <Button size="small" @click="watchEditPriceRecord(record)">查看明细</Button>
        </template>
      </Table>
      <div slot="footer">
        <Button size="large" @click="() => {editPriceRecord.showModal = false; editPriceRecord.list = []}">返回</Button>
      </div>
    </Modal>
    <!-- 查看明细 -->
    <Modal v-model="showSpecialPriceRecord.showModal" v-if="showSpecialPriceRecord.showModal" :zIndex="1001" title="订单修改记录明细" @ok="() => { showSpecialPriceRecord.showModal = false; showSpecialPriceRecord.recordObj = {} }" @cancel="() => { showSpecialPriceRecord.showModal = false; showSpecialPriceRecord.recordObj = {} }" :width="900" class="editPriceListModal">
      <table class="editPriceTable">
        <tr>
          <th>部位名称</th>
          <th>医生特殊收费</th>
          <th>增加扫描序列收费</th>
          <th>替代未出胶片收费</th>
          <th>扫描部位实际收费</th>
        </tr>
        <tr v-for="(record, rIdex) in showSpecialPriceRecord.recordObj.bodyDetailList || []" :key="rIdex">
          <td>{{ record.bodyItemName }}</td>
          <td style="width: 120px;">
            <div>{{ record.doctorSpecialCharge }}</div>
          </td>
          <td style="width: 140px;">
            <div>{{ record.addSeriesCharge }}</div>
          </td>
          <td style="width: 140px;">
            <div>{{ record.extraFilmCharge }}</div>
          </td>
          <td style="width: 140px;">
            <span>{{ record.conExCheckBodyAmount }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="4" >合计</td>
          <td>{{ showSpecialPriceRecord.recordObj.totalAmout }}</td>
        </tr>
      </table>
    </Modal>
    <!-- 修改明细 -->
    <Modal v-model="editPriceList.showModal" :zIndex="999" v-if="editPriceList.showModal" @ok="() => { editPriceList.showModal = false; }" @cancel="() => { editPriceList.showModal = false; }" :width="900" class="editPriceListModal">
      <template slot="title">
        <span>修改订单检查部位收费</span>
        <a @click="openSpecialEditRecrod">(查看修改记录)</a>
      </template>
      <table class="editPriceTable">
        <tr>
          <th>部位名称</th>
          <th>医生特殊收费</th>
          <th>增加扫描序列收费</th>
          <th>替代未出胶片收费</th>
          <th>扫描部位实际收费</th>
        </tr>
        <tr v-for="record in checkedBodyData" :key="record.body_item_id">
          <td>{{ record.body_item_name }}</td>
          <td style="width: 120px;">
            <InputNumber :min="0" style="width: 100%;" v-model="record.doctorSpecialCharge" @change="() => addExtraPrice(record)"></InputNumber>
          </td>
          <td style="width: 140px;">
            <InputNumber :min="0" style="width: 100%;" v-model="record.addSeriesCharge" @change="() => addExtraPrice(record)"></InputNumber>
          </td>
          <td style="width: 140px;">
            <InputNumber :min="0" style="width: 100%;" v-model="record.extraFilmCharge" @change="() => addExtraPrice(record)"></InputNumber>
          </td>
          <td style="width: 140px;">
            <span>{{ record.conExCheckBodyAmount }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="4" >合计</td>
          <td>{{ this.actualAmount }}</td>
        </tr>
      </table>
    </Modal>
    <!-- 匹配线上患者 -->
    <Modal v-model="showMatchModal"  v-if="showMatchModal" title="匹配" :footer="null" :width="900" @cancel="closeMatchModal">
      <onlineMatch @closeMatchModal="closeMatchModal" @handleSureMatch="handleSureMatch" :patientId="matchPatientId" modalType="first"></onlineMatch>
    </Modal>
    <!-- 上传文件 -->
    <Modal title="上传影像文件" v-model="uploadImage.uploadImageModal" :width="820">
      <div class="uploadImageWrap">
        <UploadDragger :multiple="true" v-if="uploadImage.fileList.length < 1" :beforeUpload="beforeUploadImage" :showUploadList="false">
          <p class="ant-upload-drag-icon">
            <Icon type="inbox" />
            <div class="ant-upload-text">点击或者拖拽影像文件到此区域</div>
          </p>
        </UploadDragger>
        <div class="fileList" v-if="uploadImage.fileList.length > 0">
          <div v-for="(file, index) in uploadImage.fileList" :key="index" class="fileItem">
            <img src="../../assets/images/imageIcon.png" width="40px" :alt="file.name" :title="file.name">
            <span style="height:40px;line-height:40px;margin-left:5px;">{{file.name}}</span>
            <Icon type="close-circle" theme="filled" @click="deleteUploadFile(index)"/>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div style="margin-bottom:10px;">
          <Progress :percent="1 * uploadImage.uploadPercent" status="active" v-if="uploadImage.uploadLoading || uploadImage.isComplete"/>
          <div style="text-align:left;">
            <Icon type="loading" v-if="uploadImage.uploadLoading"/>
            <span v-if="uploadImage.uploadLoading"> 正在上传，不同网络环境，上传时间可能不同，请耐心等待……</span>
            <span v-if="uploadImage.isComplete" style="color:red;"> 上传影像文件成功</span>
          </div>
        </div>
        <div v-if="!uploadImage.isComplete">
          <Upload :multiple="true" style="display:inline-block;" :beforeUpload="beforeUploadImage" :showUploadList="false">
            <Button type="primary" :disabled="uploadImage.uploadLoading">选择文件</Button>
          </Upload>
          <Upload directory style="display:inline-block;" :beforeUpload="beforeUploadImage" :showUploadList="false">
            <Button type="primary" :disabled="uploadImage.uploadLoading">选择文件夹</Button>
          </Upload>
          <Button type="primary" :loading="uploadImage.uploadLoading" @click="uploadImageAction">开始上传</Button>
        </div>
        <div v-if="uploadImage.isComplete">
          <Button type="primary" :loading="uploadImage.uploadLoading" @click="closeUploadImage">确定</Button>
        </div>
      </div>
    </Modal>
    <Modal title="上传其他文件" v-model="uploadOtherFile.uploadModal" :width="820">
      <div class="uploadImageWrap">
        <UploadDragger :multiple="true" v-if="uploadOtherFile.fileList.length < 1" :beforeUpload="beforeUploadOtherFile" :showUploadList="false">
          <p class="ant-upload-drag-icon">
            <Icon type="inbox" />
            <div class="ant-upload-text">点击或者拖文件到此区域</div>
          </p>
        </UploadDragger>
        <div class="fileList" v-if="uploadOtherFile.fileList.length > 0">
          <div v-for="(file, index) in uploadOtherFile.fileList" :key="index" class="fileItem">
            <Icon type="file" style="font-size:40px;color:#1890ff;"/>
            <span style="height:40px;line-height:40px;margin-left:5px;">{{file.name}}</span>
            <Icon type="close-circle" theme="filled" @click="deleteUploadOtherFile(index)"/>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div style="margin-bottom:10px;" v-if="uploadOtherFile.uploadLoading">
          <Progress :percent="1 * uploadOtherFile.uploadPercent" status="active" />
          <div style="text-align:left;">
            <Icon type="loading" />
            <span> 正在上传，不同网络环境，上传时间可能不同，请耐心等待……</span>
          </div>
        </div>
        <Upload :multiple="true" style="display:inline-block;" :beforeUpload="beforeUploadOtherFile" :showUploadList="false">
          <Button type="primary" :disabled="uploadOtherFile.uploadLoading || uploadOtherFile.fileList.length >= 1">选择文件</Button>
        </Upload>
        <!-- <Upload directory style="display:inline-block;" :beforeUpload="beforeUploadImage" :showUploadList="false">
          <Button type="primary" :disabled="uploadImage.uploadLoading">选择文件夹</Button>
        </Upload> -->
        <Button type="primary" :loading="uploadImage.uploadLoading" :disabled="uploadOtherFile.uploadLoading" @click="uploadOtherAction">开始上传</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { zeroPadding, toast, isSpace, getReservationDate, isDateOut, checkPhone, isArray, getParamFromRoute, getNameInitials } from '../../libs/utils'
import { Row, Col, Input, Button, Form, Card, Radio, DatePicker, Select, Table, InputNumber, Modal, Icon, Upload, Progress } from 'ant-design-vue'
import { getCheckObject, getCheckBody, getTemplate, afterHandle, sendMessage, getConsumables, saveNewCheck, getCheckOrderDetails, getPatientInfoByIdNumber, getConsumList, getCheckTimeList, nurseCancelCheck, getPatientMsgForPhone, aiUploadImage, aiUploadImageComplete, checkUploadFile, getCheckOrderInfoByOrderCode } from '../../api/check'
import { get_info_from_id_card } from '../../libs/idCard'
import checkDate from './checkTime'
import moment from 'moment'
import { switchTimeFormat, computedAge, arrayUnqiue, getSession } from '../../libs/utils'
import { mapState, mapActions } from 'vuex'
import matchDoctorList from './matchDoctorList'
import matchOrderList from './matchOrderList'
import afterDeal from './afterDeal'
import { readIdCardNo } from '../../api/user'
import { RelevantInformation, LoginUser, SelectCenter } from '../../libs/mixin'
import editDiv from '../../components/editDiv'
import onlineCheck from './moreOnlinePatient'
import onlineMatch from './onlineMatch'
import { getOnlineCheckinList, makePayCode, getChangePriceRecord } from '../../api/onlineCheckin'
import { getAiCheckImageCenterId } from '../../config'
import { sliceFile } from '../../libs/tool'
import { hasIn, cloneDeep, filter, isNumber, throttle, find, pullAllBy, uniqBy, xorWith } from 'lodash'
import { Decimal } from 'decimal.js'
import Validate from 'validate'
export default {
  mixins:[RelevantInformation, LoginUser, SelectCenter],
  components: {
    Row,
    Col,
    Input,
    Button,
    Form,
    FormItem: Form.Item,
    Card,
    Radio,
    RadioGroup: Radio.Group,
    RadioButton: Radio.Button,
    DatePicker,
    Select,
    SelectOption: Select.Option,
    TextArea: Input.TextArea,
    Table,
    checkDate,
    InputNumber,
    matchDoctorList,
    matchOrderList,
    TableColumn: Table.Column,
    afterDeal,
    Icon,
    editDiv,
    onlineCheck,
    onlineMatch,
    UploadDragger: Upload.Dragger,
    Upload: Upload,
    Progress,
    Modal
  },
  data () {
    return {
      checkNumber: '', // 检查单号
      bind_check_order_code: '', //AI订单绑定的单号
      patientName: '', // 患者姓名
      onlinePatientInfo: '', // 线上报到患者信息
      onlinePatientList: [ // 线上报到患者列表
        { id: '',
          real_name: '请选择报到患者'
        }
      ],
      patientIdNumber: '', // 身份证
      patientGender: '', // 性别
      patientBirthDay: moment(), // 出生日期
      patientAge: '', // 年龄
      ageUnit: 50, // 年龄单位
      patientMobile: '', // 患者手机号
      patientHeight: '', // 患者身高
      patientWeight: '', // 患者体重
      blood_pressure: '',// 血压
      anamnesis: '', // 病史
      outpatient_inpatient: true, // 门诊/住院
      emergency: false, // 是否急诊
      medical_insurance: false, // 是否医保
      hospitalBed: '',
      admissionNumber: '',
      orderSource: '线下',
      // hospitalCheckItemIds: [], //设备部位ID
      equivalentCount: 0, // 折算系数
      // itemCheckbaseElementIds: [], //后处理ID
      remark: { // 备注
        doctor: '',
        operation: '',
        nurse: ''
      },
      chargeChannel: '', // 支付方式
      service_appointment_datetime: '', // 预约时间
      service_appointment_time: '',  // 预约时间
      amount: 0, // 医疗费用
      actualAmount: 0, // 实际费用
      lastActualAmount: 0,
      report_required: true, // 是否需要报告
      checkDevice: '',
      hospitalNameDefaultVal: '', // 检查医院
      checkObjectVal: '',
      checkBodyList: [],
      searchBodyName: '',
      afterHandleList: [], // 后处理
      tableData: [],
      labelCol: {
        md: {span: 3}, lg: { span: 2 }, xl: { span: 6 }, xxl: { span: 4 }, xs: {span: 4}
      },
      wrapperCol: {
        md: {span: 21}, lg: { span: 22 }, xl: { span: 18 }, xxl: { span: 20 }, xs: {span: 20}
      },
      labelColAnthor: {
        md: {span: 8}, lg: { span: 6 }, xl: { span: 7 }, xxl: { span: 5 }
      },
      wrapperColAnthor: {
        md: {span: 16}, lg: { span: 18 }, xl: { span: 16 }, xxl: { span: 18 }
      },
      showCheckDate: false,
      imageCenterId: null,
      checkText: '选择',
      checkOrderId: 0,
      checkOrderStatus: '',
      disMatch: true,
      from: '',
      showMatchDoctorModal: false, //匹配医生列表
      showMatchOrderList: false, //匹配订单列表
      bodyCheckedList: [
        { title: '检查部位', dataIndex: 'body_item_name', scopedSlots: { customRender: 'bodyName' } },
        { title: '数量', dataIndex: 'bodyNum', scopedSlots: { customRender: 'bodyNum' } },
        { title: '删除', dataIndex: 'handleBody', scopedSlots: { customRender: 'handleBody' } }
      ],
      checkedBodyData: [],
      showAfterDealList: false,
      dealTag: [],
      mateTitle: '匹配',
      consumData: [],
      doctorId: 0, // 匹配医生ID
      orderCode: 0, // 匹配订单code
      submitLoading: false,
      editDateFlag: false, // 编写预约时间
      editPriceFlag: false, // 修改价格
      setllmentStatue: '',
      editMacthFlag: true,
      checkObjectList: [],
      setCurrentHospitalVal: null, // 当前组件的当前影像中心
      setCurDeviceVal: null, // 当前组件的当前检查设备
      signWaitOrder: {
        openFlag: false,
        reason: null,
        reasonList: [
          { key: 1, label: '患者不确定检查时间' },
          { key: 2, label: '患者不确定身体是否适合检查' },
          { key: 3, label: '患者不确定是否做检查' },
          { key: 4, label: '等待检查医院确认检查时间' },
          { key: 5, label: '暂未联系上，稍后联系' },
          { key: 6, label: '其他' },
        ],
        otherReasonMsg: '',
        showWaitBtn: false,
      },
      cancelOrder: {
        openFlag: false,
        showCancelBtn: false
      },
      operationCanNotEdit: null,
      isEditedOperation: false,
      role: null,
      changeImageCenter: false,
      orderWaitEditStatus: false,
      sendMsg: {
        openFlag: false,
        content: ''
      },
      isReceiptSuccess: false,
      msgInfo: {
        patient_mobile: '',
        patient_name: '',
        hospital_name: '',
        body_names: '',
        year: '',
        month: '',
        day: '',
        time: '',
        hospital_address: '',
        hospital_route: ''
      },
      isAppointmentCheck: false,
      showWaitFlag: false,
      isNurseEditFlag: false, // 护士编辑
      isInHospitalCheckFlag: false, // 点击到院检查
      waitingFlag: false,
      isNeedReportEditFlag: false,
      sendPatientId: '',
      showCopyInfo: false,
      copyInfo: '',
      isItemManager: true, // 是否项目管理中心
      isShowReport: false, // 展示是否需要报告
      isSetllmentStatus: false, // 结算状态
      isSettlementCheckStatus: '', // 是否问题订单
      settlement_check_status_name: '',
      isFromCallNumPage: false, // 技师工作站跳转
      sureSendMsgLoading: false,
      showMoreOnlinePatient: false, // 更多患者
      noMatchPatient: false, // 未匹配患者
      idOrderPayedFlag: true,
      showMatchModal: false,
      matchPatientId: '',
      matchSureFlag: false,
      noChangePatientFlag: false,
      kzOrderFlag: false,
      paymentStatus: '',
      oldChannel: '',
      cardAddress: '',
      uploadImage: {
        targetImageCenterId: getAiCheckImageCenterId(),
        uploadImageModal: false,
        fileList: [],
        uploadLoading: false,
        uploadPercent: 0,
        isComplete: false
      },
      uploadOtherFile: {
        targetImageCenterId: getAiCheckImageCenterId(),
        uploadModal: false,
        fileList: [],
        uploadLoading: false,
        uploadPercent: 0
      },
      editPriceRecord: {
        showModal: false,
        list: [],
        columns: [
          { title: '序号', customRender: (text, record, index) => `${index + 1}` },
          { title: '修改时间', dataIndex: 'updated_date' },
          { title: '修改前金额', dataIndex: 'old_value' },
          { title: '修改后金额', dataIndex: 'new_value' },
          { title: '操作人', dataIndex: 'creator' },
          { title: '操作', scopedSlots: { customRender: 'control' } }
        ]
      },
      editPriceList: {
        showModal: false
      },
      showSpecialPriceRecord: {
        showModal: false,
        recordObj: {}
      },
      charge_share_type: 0
    }
  },
  async mounted () {
    this.setCurrentHospitalVal = this.currentCenterId
    this.setCurDeviceVal = this.curDeviceId
    this.role = getSession('userAuth', 'object').roles || null
    await this.getDeviceList()
    await this.getOnlinePatient()
    if (this.payType) this.chargeChannel = this.payType
    if (this.hospitalFlag) this.isShowReport = true
    // 默认设置选择时间
    if (!this.hospitalFlag || (this.currentCenterId == this.uploadImage.targetImageCenterId)) {
      await this.setCheckTime()
    }
    let routerParams = getParamFromRoute(this.$route) || {}
    if (routerParams.addNewOrder) this.idOrderPayedFlag = false
    if (routerParams.checkOrderId) {
      this.relInformation.checkOrderId = this.checkOrderId = routerParams.checkOrderId
      this.from = routerParams.from
      await this.getCheckDetails(routerParams.checkOrderId)
      await this.initRelevantInfoData()
      if (this.checkOrderStatus === 50 || this.checkOrderStatus === 20) {
        this.checkOrderStatus = 50
      }
    }
    if (routerParams.isReceiptSuccess) {
      this.isReceiptSuccess = true
    }
    if (routerParams.isAppointmentCheck) {
      this.isAppointmentCheck = true
      this.orderSource = '快诊'
    }
    if (routerParams.isNurseEditFlag) {
      this.isNurseEditFlag = true
    }
    if (routerParams.isNurseEditFlag && this.orderSource === '快诊') {
      this.kzOrderFlag = true
    }
    if (routerParams.isInHospitalCheckFlag) {
      this.isInHospitalCheckFlag = true
    }
    if (this.$route.query.checkOrderId && !this.isInHospitalCheckFlag) {
      this.noChangePatientFlag = true
    } else {
      this.noChangePatientFlag = false
    }
    // 检查运营编辑逻辑
    if (routerParams.isEditedOperation && routerParams.isEditedOperation) {
      this.isEditedOperation = true
    } else if ((routerParams.isEditedOperation && !routerParams.isEditedOperation)) {
      this.isEditedOperation = false
    }
    if (this.checkOrderStatus === 0 || this.checkOrderStatus === 8) {
      if (this.from === 'editKzFlag' || this.from === 'addKzFlag') {
        this.showWaitFlag = true
      } else {
        this.showWaitFlag = false
      }
    }
    if (this.isRole('ROLE_ROOT') && this.from === 'editKzFlag') {
      if (this.checkOrderStatus === 5) {
        this.cancelOrder.showCancelBtn = true
        this.orderWaitEditStatus = true
      }
      else this.signWaitOrder.showWaitBtn = true
    } else if (this.isRole('ROLE_CHECK_OPERATING') && !this.isRole('ROLE_ROOT') && this.from === 'editKzFlag') {
      if (this.checkOrderStatus === 5) {
        this.cancelOrder.showCancelBtn = true
        this.orderWaitEditStatus = true
      }
      else this.signWaitOrder.showWaitBtn = true
    }
    if (!this.isRole('ROLE_CHECK_OPERATING') && !this.isRole('ROLE_ROOT') && this.from === 'editKzFlag') {
      this.changeImageCenter = true
    }
    // 非检查运营编辑
    if (this.from === 'callNum' && this.checkOrderStatus === 10) {
      this.checkOrderStatus = 50
      this.editDateFlag = false
      this.editPriceFlag = true
      this.isNeedReportEditFlag = false
    } else if (this.from === 'queue' && this.checkOrderStatus === 60) {
      this.editDateFlag = true
      this.editPriceFlag = false
      this.isNeedReportEditFlag = false
    } else if (this.from === 'callNum' && this.checkOrderStatus === 60) {
      this.checkOrderStatus = 50
      this.editDateFlag = true
      this.editPriceFlag = true
      this.isNeedReportEditFlag = false
    } else if (this.from === 'historyCheck' && this.checkOrderStatus === 60) {
      this.editDateFlag = true
      this.editPriceFlag = false
      this.isNeedReportEditFlag = false
    } else if (this.from === 'callNum' && this.checkOrderStatus === 50) {
      this.editDateFlag = true
      this.editPriceFlag = true
      this.isNeedReportEditFlag = true
    } else if (this.from === 'queue' && this.checkOrderStatus === 50) {
      this.isNeedReportEditFlag = true
    } else if (this.from === 'historyCheck' && this.checkOrderStatus === 50) {
      this.isNeedReportEditFlag = true
    }
    if (this.from === 'historyCheck' || this.from === 'callNum') {
      if (this.orderSource === '快诊') {
        this.isInHospitalCheckFlag = true
      }
    }
    if (this.from === 'callNum') {
      this.isFromCallNumPage = true
    }
    // 根据结算状态的编辑
    if (this.setllmentStatue === 100 || this.setllmentStatue === 10) {
      this.editPriceFlag = true
      this.editMacthFlag = true
      this.disMatch = true
      this.isSetllmentStatus = true
      console.log('根据结算状态的编辑 isSetllmentStatus:' + this.isSetllmentStatus)
    } else {
      this.editPriceFlag = false
      this.disMatch = false
      this.editMacthFlag = false
      this.isSetllmentStatus = false
      console.log('根据结算状态的编辑 isSetllmentStatus:' + this.isSetllmentStatus)
    }
    // 根据角色的编辑
    for (let i = 0; i < this.role.length; i++) {
      let item = this.role[i]
      if (item.rcode === 'ROLE_MANAGEMENT_CENTER') {
        this.editPriceFlag = false
        this.disMatch = false
        this.editMacthFlag = false
        this.editDateFlag = false
        this.checkOrderStatus = 999
        this.isItemManager = false
        break
      }
    }
    await this.getCenterConsumData()
  },
  computed: {
    ...mapState({
      currentCenterId: state => state.app.currentCenterId,
      currentCenterName: state => state.app.currentCenterName,
      deviceList: state => state.app.devices,
      curDeviceId: state => state.app.curDevice,
      payType: state => state.app.payType,
      hospitalFlag: state => state.app.hospitalFlag
    }),
    afterDealTag () {
      let tagName = []
      if (this.afterHandleList.length === 0) return ''
      else {
        for (let i = 0; i < this.afterHandleList.length; i++) {
          let item = this.afterHandleList[i]
          tagName.push(item.base_element_name || item.name)
        }
        return tagName.toString()
      }
    }
  },
  methods: {
    ...mapActions([
      'setCurDevice',
      'setCurrentCenter',
      'initTakePhotoSocket'
    ]),
    async asyncPatientInfo () {
      const data = await getCheckOrderInfoByOrderCode({ checkOrderCode: this.bind_check_order_code })
      if (!data) return false
      this.setPatientInfoByOrderInfo(data)
    },
    copyCheckNumberSuccess() {
      return toast({ msg: '复制检查单号成功', title: '操作提示', type: 'success' })
    },
    copyCheckNumberError () {
      return toast({ msg: '复制检查单号失败，请刷新页面重试' })
    },
    // 非自营默认给他设置一个预约时间
    async setCheckTime() {
      let params = {
        medicalImageCenterId: this.currentCenterId,
        medicalImageCenterDeviceId: this.curDeviceId,
        isShowScheduled: true
      }
      params.queueUpDate = getReservationDate().format('YYYY-MM-DD') + ' 00:00:00'
      let data = await getCheckTimeList(params)
      if (!data) return false
      let list = data.nowAppointTimeList.list.concat(data.nextAppointTimeList.list)
      for (let i = 0; i < list.length; i++) {
        let item = list[i]
        let appointmentDatetime = item.appointmentDatetime.substring(0, 10)
        let appointmentTime = zeroPadding(item.appointmentTime)
        let checkText = appointmentDatetime +" "+ appointmentTime
        if (!item.isAppointment && !isDateOut(checkText)) {
          this.service_appointment_datetime = appointmentDatetime
          this.service_appointment_time = item.appointmentTime
          this.checkText = checkText
          return true
        }
      }
    },
    // 获取设备列表
    async getDeviceList () {
      try {
        this.setCurDeviceVal = this.curDeviceId
        let bodyCateList = await getCheckObject({ deviceId: this.curDeviceId })
        if (!isArray(bodyCateList) || bodyCateList.length < 1) throw Error('获取检查分类异常')
        this.checkObjectList = bodyCateList
        this.checkObjectVal = bodyCateList[0].body_id
        const params = {
          medicalImageCenterDeviceId: this.curDeviceId,
          bodyId: this.checkObjectVal
        }
        if (this.searchBodyName) params.bodyItemName = this.searchBodyName
        let bodyData = await getCheckBody(params)
        this.checkBodyList = bodyData
      } catch (error) {
        toast({ msg: error.message })
      }
    },
    // 获取影像中心耗材
    async getCenterConsumData () {
      let data = await getConsumList({ medicalImageCenterId: this.currentCenterId})
      if (data) this.consumData = data
    },
    // 获取最近报到的患者
    async getOnlinePatient () {
      let params = { pageNumber: 1, pageSize: 5, imageCenterId: this.currentCenterId }
      let data = await getOnlineCheckinList(params)
      if (!data) return false
      this.onlinePatientList = this.onlinePatientList.concat(data.results)
    },
    setAgeUnit() {
      let ageResult = computedAge(switchTimeFormat(this.patientBirthDay, 6))
      this.patientAge = ageResult.age
      if (ageResult.age_unit === 'M') {
        this.ageUnit = 30
      } else if (ageResult.age_unit === 'Y') {
        this.ageUnit = 50
      } else if (ageResult.age_unit === 'W') {
        this.ageUnit = 20
      } else if (ageResult.age_unit === 'D') {
        this.ageUnit = 10
      }
    },
    // 设置患者信息
    setPatientInfoByOrderInfo (data) {
      // 身份信息
      this.patientIdNumber = data.id_number
      if (data.patient_address) this.cardAddress = data.patient_address
      // 手机号
      if (data.mobile && data.mobile.substr(0,1) === '1') {
        this.patientMobile = data.mobile
      } else {
        this.patientMobile = data.phone
      }
      this.patientName = data.real_name || data.patient_name
      //性别
      if (hasIn(data, 'gender')) {
        this.patientGender = data.gender && data.gender.toString()
      } else if (hasIn(data, 'sex')) {
        this.patientGender = data.sex && data.sex.toString()
      }
      // 生日年龄
      if (data.birth_date) {
        this.patientBirthDay = moment(data.birth_date)
      } else {
        this.patientBirthDay = moment()
      }
      if (data.age) {
        this.patientAge = data.age
        this.ageUnit = data.age_unit
      }
      //身高体重
      this.patientHeight = data.height
      this.patientWeight = data.weight
      // 既往病史
      if (data.medical_history) this.anamnesis = data.medical_history
      // 患者来源
      this.orderSource = data.order_source

      if (['快诊', '线下', '科研检查单'].includes(data.order_source)) {
        if (data.doctor_name) {
          this.mateTitle = this.formatDoctorMateTitle(data.doctor_id, data.doctor_name)
          this.doctorId = data.doctor_id
        } else {
          this.mateTitle = '无匹配项'
        }
      }
      if (data.order_source === '院内患者' || data.order_source === '医院体检') {
        this.disMatch = true
        this.mateTitle = '无匹配项'
        this.doctorId = 0
        this.orderCode = 0
      }
      //门诊住院
      this.outpatient_inpatient = data.outpatient_inpatient
      if (data.admissionNumber || data.admission_number) this.admissionNumber = data.admissionNumber || data.admission_number
      if (data.hospitalBed || data.hospital_bed) this.hospitalBed = data.hospitalBed || data.hospital_bed
      // 急诊和医保
      this.emergency = data.emergency
      this.medical_insurance = data.medical_insurance
      // 护士和医生备注
      this.remark.nurse = data.remark
      this.remark.doctor = data.doctor_comment
      // 设置血压
      if (data.blood_pressure) {
        let bloodStr = JSON.parse(data.blood_pressure)
        if (bloodStr.value) this.blood_pressure = bloodStr.value
      }
      this.sendPatientId = data.patient_id
      if (data.online_agent_comment) this.remark.operation = data.online_agent_comment
    },
    // 获取检查订单详情
    async getCheckDetails (checkOrderId) {
      let data = await getCheckOrderDetails({ id: checkOrderId})
      if (!data) return false
      if (data.hospital_medical_image_center_id) await this.changeCurrentHospital({hospital_medical_image_center_id: data.hospital_medical_image_center_id, device_id: data.device_id})
        this.setPatientInfoByOrderInfo(data)
        this.checkOrderStatus = data.status
        this.setllmentStatue = data.settlement_status
        this.isSettlementCheckStatus = data.settlement_check_status
        this.settlement_check_status_name = data.settlement_check_status_name || ''
        this.report_required = data.report_required
        this.charge_share_type = data.charge_share_type
        if (data.charge_channel) {
          this.oldChannel = data.charge_channel
          this.chargeChannel = data.charge_channel
        } else if (this.payType) {
          this.chargeChannel = this.payType
        } else {
          this.chargeChannel = ''
        }
        this.equivalentCount = data.equivalent_count
        this.checkNumber = data.order_code
        if (data.bind_check_order_code) this.bind_check_order_code = data.bind_check_order_code
        this.afterHandleList = data.baseElementList || []
        this.onlinePatientInfo = data.checkin_id || ''
        this.setCurDeviceVal = data.device_id
        this.paymentStatus = data.paymentStatus
        this.amount = data.price_total
        this.actualAmount = data.price
        this.lastActualAmount = data.price
        this.setCurDevice(data.device_id)
        if (data.paymentStatus === 20 && (this.chargeChannel==='线上-微信'||this.chargeChannel==='线上-支付宝')) {
          this.idOrderPayedFlag = true
        } else {
          this.idOrderPayedFlag = false
        }
        if (isArray(data.checkItemList) && data.checkItemList.length > 0) {
          for (let i = 0; i < data.checkItemList.length; i++) {
            let item = data.checkItemList[i]
            const checkBodyItem = find(this.checkBodyList, { id: item.id })
            if (checkBodyItem) checkBodyItem.checked = true
            this.tableData.push({ type: 'base', check_item_id: item.id, body_item_id: item.body_item_id, count: item.chargeCount, materialAmount: new Decimal(item.base_cost).mul(item.chargeCount).toNumber(), materialName: item.name, materialPrice: item.base_cost, })
            const checkMaterialList = item.material_info || []
            for (let i = 0; i < checkMaterialList.length; i++) {
              this.tableData.push(checkMaterialList[i])
            }
            let obj = {
              bodyNum: item.chargeCount,
              check_item_id: item.id,
              body_item_name: item.name,
              body_item_id: item.body_item_id,
              equivalent_count: item.equivalent_count,
              notConExCheckBodyAmount: 0,
              conExCheckBodyAmount: 0,
              doctorSpecialCharge: 0,
              addSeriesCharge: 0,
              extraFilmCharge: 0
            }
            if (item.charge_diff_description) {
              obj.doctorSpecialCharge = item.charge_diff_description['医生特殊收费'] || 0
              obj.addSeriesCharge = item.charge_diff_description['增加扫描序列收费'] || 0
              obj.extraFilmCharge = item.charge_diff_description['替代未出胶片收费'] || 0
            }
            this.checkedBodyData.push(obj)
            this.updatePerCheckedBodyAmount(obj)
          }
          this.computedTotalMoney()
        }
        if (data.status === 50 || data.status === 20) {
          this.editDateFlag = true
        }
        if (data.service_appointment_actual_datetime) {
          this.service_appointment_datetime = data.service_appointment_actual_datetime.slice(0, 10)
          this.service_appointment_time = data.service_appointment_time
          this.checkText = this.service_appointment_datetime + ' ' + zeroPadding(this.service_appointment_time)
        }
    },
    // 选择线上报到的患者
    changeOnlinePatient (val) {
      if (!val) return false
      this.matchPatientId = val
      this.showMatchModal = true
    },
    closeMatchModal () {
      if (this.matchPatientId && this.patientIdNumber) {
        this.showMatchModal = false
      } else {
        this.matchPatientId = ''
        this.onlinePatientInfo = ''
        this.showMatchModal = false
      }
    },
    // 查看更多线上报的患者
    moreOnlinePatient () {
      this.showMoreOnlinePatient = true
    },
    closeOnlinePatientModal () {
      this.showMoreOnlinePatient = false
    },
    // 确认匹配线上患者
    handleSureMatch (val) {
      this.showMatchModal = false
      this.showMoreOnlinePatient = false
      let arr = []
      this.onlinePatientList.forEach(item => {
        arr.push(item.id)
      })
      if (arr.indexOf(val.id) === -1) this.onlinePatientList.push(val)
      this.onlinePatientInfo = val.id
      this.sendPatientId = val.patient_id
      this.matchSureFlag = val.matchFlag
      this.patientName = val.real_name
      this.patientIdNumber = val.id_number
      this.patientGender = val.gender.toString()
      this.patientBirthDay = moment(val.birth_date)
      this.setAgeUnit()
      this.patientMobile = val.mobile
      this.patientHeight = val.height
      this.patientWeight = val.weight
    },
    // 确定保存未匹配患者的订单
    async sureMatchPatient () {
      this.noMatchPatient = false
      await this.handleSubmit()
    },
    // 点击修改实际费用
    async handleChangePirce () {
      // 编辑订单
      if (this.checkedBodyData.length < 1) return toast({ msg: '暂无检查部位信息' })
      this.editPriceList.showModal = true
    },
    // 改变数量后的价格变化
    changeMaterialCount (record) {
      if (record && record.count) {
        record.materialAmount = new Decimal(record.materialPrice).mul(record.count)
      }
      const checkedBody = find(this.checkedBodyData, { check_item_id: record.check_item_id })
      this.updatePerCheckedBodyAmount(checkedBody)
      this.computedTotalMoney()
    },
    computedTotalMoney () {
      let notConExAllAmount = new Decimal(0)
      let conExAllAmount = new Decimal(0)
      for(let i = 0; i < this.checkedBodyData.length; i++) {
        const checkedBody = this.checkedBodyData[i]
        notConExAllAmount = notConExAllAmount.plus(checkedBody.notConExCheckBodyAmount)
        conExAllAmount = conExAllAmount.plus(checkedBody.conExCheckBodyAmount)
      }
      this.amount = notConExAllAmount.toNumber()
      if (['内部福利单', '外部福利单', '科研检查单'].includes(this.orderSource)) {
        this.actualAmount = 0
      } else {
        this.actualAmount = conExAllAmount.toNumber()
      }
    },
    // 获取检查分类列表
    async changeCheckObject () {
      const params = { medicalImageCenterDeviceId: this.curDeviceId }
      if (this.checkObjectVal === '特色检查') {
        params.uniqueCheck = true
      } else {
        params.bodyId = this.checkObjectVal
      }
      if (this.searchBodyName) params.bodyItemName = this.searchBodyName
      try {
        let bodyList = await getCheckBody(params) || []
        if (!isArray(bodyList)) throw Error('获取检查部位失败')
        for (let i = 0; i < this.checkedBodyData.length; i++) {
          let item = this.checkedBodyData[i]
          const findBodyItem = find(bodyList, { id: item.check_item_id })
          if (findBodyItem) findBodyItem.checked = true
        }
        this.checkBodyList = bodyList
      } catch (error) {
        toast({ msg: error.message })
      }
    },
    // 判断患者出生日期不能为未来日期
    disabledDate (current) {
      return current > moment()
    },
    updatePerCheckedBodyAmount (checkedItem) {
      let extraChargeAmount = new Decimal(checkedItem.doctorSpecialCharge).plus(checkedItem.addSeriesCharge).plus(checkedItem.extraFilmCharge)
      let allMaterialAmount = 0
      const checkMaterials = filter(this.tableData, { check_item_id: checkedItem.check_item_id }) || []
      for (let i = 0; i < checkMaterials.length; i++) {
        const material = checkMaterials[i]
        allMaterialAmount = new Decimal(material.materialPrice).mul(material.count).plus(allMaterialAmount)
      }
      checkedItem.conExCheckBodyAmount = extraChargeAmount.plus(allMaterialAmount).toNumber()
      checkedItem.notConExCheckBodyAmount = allMaterialAmount.toNumber()
    },
    async addCheckBody (item) {
      item.checked = true
      const checkedBody = {
        check_item_id: item.id,
        bodyNum: 1,
        body_item_name: item.alias || item.body_item_name,
        body_item_id: item.body_item_id,
        equivalent_count: item.equivalent_count,
        doctorSpecialCharge: 0,
        addSeriesCharge: 0,
        extraFilmCharge: 0,
        notConExCheckBodyAmount: 0,
        conExCheckBodyAmount: 0
      }
      this.checkedBodyData.push(checkedBody)
      this.equivalentCount = 1 * this.equivalentCount + 1 * item.equivalent_count
      await this.handleAfterProcess('add', item)
      await this.handleTableData('add', checkedBody)
    },
    // 添加或删除部位
    handleClickCheckBody: throttle(async function (item) {
      if (item.checked) return this.removeCheckBody(item)
      else return await this.addCheckBody(item)
    },800),
    // 处理扫描费和耗材
    async handleTableData (type, checkedBody) {
      if (type === 'add') {
        let result = await getConsumables({ id: checkedBody.check_item_id })
        if (!result || !result.id) return false
        this.tableData.push({
          materialId: checkedBody.check_item_id,
          check_item_id: checkedBody.check_item_id,
          materialName: checkedBody.body_item_name,
          body_item_id: checkedBody.body_item_id,
          count: 1,
          materialAmount: result.base_cost,
          materialPrice: result.base_cost,
          type: 'base'
        })
        if (hasIn(result, 'materialList') && isArray(result.materialList) && result.materialList.length > 0) {
          for (let i = 0; i < result.materialList.length; i++) {
            const material = result.materialList[i]
            const obj = Object.assign({}, material, { type: 'material', check_item_id: checkedBody.check_item_id, body_item_id: checkedBody.body_item_id, materialId: material.id, })
            delete obj.id
            delete obj.supplier
            delete obj.manufacter
            this.tableData.push(obj)
          }
        }
        this.updatePerCheckedBodyAmount(checkedBody)
      } else if (type === 'delete') {
        const tempTableData = cloneDeep(this.tableData)
        const arr = pullAllBy(tempTableData, [{ check_item_id: checkedBody.check_item_id }], 'check_item_id')
        this.tableData = arr
      }
      this.computedTotalMoney()
    },
    // 处理后处理
    async handleAfterProcess (type, item) {
      if (type === 'add') {
        let data = await afterHandle({ bodyItemId: item.body_item_id, processType: 10 })
        if (!data || data.length <= 0) return false
        let arr = []
        for (let i = 0; i < data.length; i++) {
          let obj = {}
          obj.id = data[i].id
          obj.privateBaseElement = true
          obj.body_item_id = item.body_item_id
          obj.base_element_name = data[i].base_element_name || data[i].name
          obj.body_item_name = data[i].body_item_name
          obj.base_element_id = data[i].base_element_id
          arr.push(obj)
        }
        this.afterHandleList = this.afterHandleList.concat(arr)
      }
      if (type === 'delete') {
        if (this.afterHandleList.length <=0) return false
        let data = await afterHandle({ bodyItemId: item.body_item_id, processType: 10 })
        if (!data || data.length <= 0) return false
        for (let i = 0; i < data.length; i++) {
          for (let j = 0; j < this.afterHandleList.length; j++) {
            if (this.afterHandleList[j].id === data[i].id) {
              this.afterHandleList.splice(j, 1)
            }
          }
        }
      }
    },
    computeEquivalentCount() {
      this.equivalentCount = 0
      let totalEquivalentCount = new Decimal(0)
      for (let i = 0; i < this.checkedBodyData.length; i++) {
        let item = this.checkedBodyData[i]
        totalEquivalentCount = new Decimal(item.equivalent_count).mul(item.bodyNum).plus(totalEquivalentCount)
      }
      this.equivalentCount = totalEquivalentCount.toNumber()
    },
    // 修改部位数量
    async itemBodyNum (record) {
      this.computeEquivalentCount(record)
      const tabelDataItem = find(this.tableData, { check_item_id: record.check_item_id })
      tabelDataItem.count = record.bodyNum
      let result = await getConsumables({ id: record.check_item_id })
      if (isArray(result.materialList) && result.materialList.length >= 1) {
        for (let i = 0; i < result.materialList.length; i++) {
          const materialItem = result.materialList[i]
          const findMaterial = find(this.tableData, { type: 'material', materialName: materialItem.materialName, check_item_id: record.check_item_id, body_item_id: record.body_item_id, materialId: materialItem.id })
          if (findMaterial) {
            const countNum = new Decimal(materialItem.count).mul(record.bodyNum).toNumber()
            findMaterial.count = countNum
            findMaterial.materialAmount = new Decimal(countNum).mul(materialItem.materialPrice)
          }
        }
      }
      this.updatePerCheckedBodyAmount(record)
      this.computedTotalMoney()
    },
    // 删除部位
    async removeCheckBody (item) {
      if (this.equivalentCount > 0) this.equivalentCount = this.equivalentCount * 1 - item.equivalent_count * item.bodyNum
      if (!item.check_item_id) item.check_item_id = item.id
      const checkItem = find(this.checkBodyList, { id: item.check_item_id })
      if (checkItem) checkItem.checked = false
      this.handleAfterProcess('delete', item)
      this.handleTableData('delete', item)
      const cloneCheckedBodyData = cloneDeep(this.checkedBodyData)
      const arr = pullAllBy(cloneCheckedBodyData, [{ check_item_id: item.check_item_id }], 'check_item_id')
      this.checkedBodyData = arr
      this.computedTotalMoney()
    },
    // 根据身份证号码匹配获取患者信息
    async handleIdNumber () {
      if (this.patientIdNumber.length === 0) {
        let readPatient = await readIdCardNo()
        if (readPatient && readPatient.cardno) {
          this.patientIdNumber = readPatient.cardno
          this.patientName = readPatient.name
          this.cardAddress = readPatient.address || ''
        }
      }
      let timer = setTimeout(async() => {
        let patientInfo = get_info_from_id_card(this.patientIdNumber)
        if (!patientInfo.status) return toast({msg: patientInfo.msg})
        this.patientGender = patientInfo.sex
        this.patientBirthDay = moment(switchTimeFormat(patientInfo.birthday, 1))
        this.setAgeUnit()
        let data = await getPatientInfoByIdNumber({ idNumber: this.patientIdNumber})
        if (!this.patientName) this.patientName = data.real_name || ''
        if (data.mobile && data.mobile.substr(0,1) === '1') this.patientMobile = data.mobile
        if (data.height) this.patientHeight = data.height
        if (data.weight) this.patientWeight = data.weight
        if (data.id) this.sendPatientId = data.id
        if (data.medical_history) this.anamnesis = data.medical_history
        if (!this.cardAddress && data.address) this.cardAddress = data.address
        clearTimeout(timer)
        timer = null
      }, 2000)
    },
    // 取消该订单的创建
    handleRemove () {
      let that = this
      if (this.checkOrderId) {
        that.$router.go(-1)
      } else {
        if (this.patientName || this.patientAge || this.actualAmount || this.chargeChannel) {
          return Modal.confirm({
            title: '是否取消新增检查？',
            okText: '是',
            cancelText: '否',
            onOk () {
              that.$router.go(-1)
            }
          })
        } else {
          that.$router.go(-1)
        }
      }

    },
    // 修改患者来源
    changeOrderSource () {
      const notMatchEnum = ['院内患者', '医院体检', '内部福利单', '外部福利单']
      if (notMatchEnum.includes(this.orderSource)) {
        this.noDoctorMate()
        this.disMatch = true
      } else {
        this.mateTitle = '匹配'
        this.disMatch = false
      }
      this.computedTotalMoney()
    },
    // 新增后处理标签
    newAddAfterDeal (val) {
      this.afterHandleList = val
      this.afterHandleList = arrayUnqiue(this.afterHandleList, 'id')
      this.closeAfterDeal()
    },
    // 新增耗材
    addNewConsum (record, index) {
      if (!isArray(this.consumData) || this.consumData.length < 1) return toast({ msg: '当前影像中心，暂无耗材' , type: 'error' })
      if (!isArray(this.checkedBodyData) || this.checkedBodyData.length < 1) return toast({ msg: '请先选择要检查部位' , type: 'error' })
      const material = {
        material_name: this.consumData[0].material_name,
        count: 1,
        materialId: this.consumData[0].id,
        materialAmount: this.consumData[0].price,
        body_item_id: record.body_item_id,
        check_item_id: record.check_item_id,
        materialPrice: this.consumData[0].price,
        type: 'material'
      }
      this.tableData.splice(index + 1, 0, material)
      this.changeMaterialCount(material)
      this.computedTotalMoney()
    },
    handleChangeData (record) {
      const material = find(this.consumData, { id: record.materialId })
      record.count = 1
      record.materialAmount = material.price,
      record.materialPrice = material.price
      const checkedBody = find(this.checkedBodyData, { check_item_id: record.check_item_id })
      this.updatePerCheckedBodyAmount(checkedBody)
      this.computedTotalMoney()
    },
    // 删除耗材
    removeConsum (record) {
      const checkedBody = find(this.checkedBodyData, { check_item_id: record.check_item_id })
      this.tableData.splice(this.tableData.indexOf(record), 1)
      this.updatePerCheckedBodyAmount(checkedBody)
      this.computedTotalMoney()
    },
    // 选择后处理标签
    choiceAfterDeal () {
      if (this.checkedBodyData.length <= 0) return toast({msg: '请先选择检查项目', title: '提示', type: 'warning'})
      this.showAfterDealList = true
    },
    closeAfterDeal () {
      this.showAfterDealList = false
    },
    changeBirthday (date) {
      let ageResult = computedAge(switchTimeFormat(moment(date)._d, 6))
      this.patientAge = ageResult.age
      if (ageResult.age_unit === 'M') {
        this.ageUnit = 30
      } else if (ageResult.age_unit === 'Y') {
        this.ageUnit = 50
      } else if (ageResult.age_unit === 'W') {
        this.ageUnit = 20
      } else if (ageResult.age_unit === 'D') {
        this.ageUnit = 10
      }
    },
    // 保存订单之前发送短信的确认框
    saveOrderAndSendMsg () {
      if (this.checkOrderItem()) {
        return this.handleSubmit()
      }
    },
    // 确认发送短信
    async sureSendMsg () {
      if (this.sureSendMsgLoading) return false
      const schema = new Validate({
        patient_name: {
          required: true,
          message: '请填写患者姓名'
        },
        hospital_name: {
          required: true,
          message: '请填写医院名称'
        },
        body_names: {
          required: true,
          message: '请填写检查部位'
        },
        month: {
          required: true,
          message: '请填写检查的日期时间'
        },
        day: {
          required: true,
          message: '请填写检查的日期时间'
        },
        time: {
          required: true,
          message: '请填写检查的日期时间'
        },
        hospital_route: {
          required: true,
          message: '请填写乘车路线'
        },
        hospital_address: {
          required: true,
          message: '请填写医院地址'
        },
        patient_mobile: {
          required: true,
          message: '请填写联系电话'
        }
      })
      const cloneParams = cloneDeep(this.msgInfo)
      const errors = schema.validate(cloneParams)
      if (errors && errors[0]) return toast({msg: errors[0].message, title: '提示', type: 'warning'})
      let params = {
        mobile: this.patientMobile,
        tongxin_mobile: this.msgInfo.patient_mobile,
        patient_name: this.msgInfo.patient_name,
        hospital_name: this.msgInfo.hospital_name,
        body_names: this.msgInfo.body_names,
        appointment_date: this.msgInfo.year + '-' + this.msgInfo.month + '-' + this.msgInfo.day + ' ' + this.msgInfo.time,
        hospital_address: this.msgInfo.hospital_address,
        hospital_route: this.msgInfo.hospital_route
      }
      this.sureSendMsgLoading = true
      let data = await sendMessage(params)
      if (data) {
        this.sendMsg.openFlag = false
        this.$router.back()
      }
      this.sureSendMsgLoading = false
    },
    cancelSendMsg () {
      this.$router.back()
    },
    // 校验检查单的必填项
    checkOrderItem () {
      // AI订单必填电话号码
      if (this.currentCenterId == this.uploadImage.targetImageCenterId) {
        if (!checkPhone(this.patientMobile)) {
          Modal.error({ title: '请填写正确的手机号' })
          return false
        }
        if (this.mateTitle === '匹配' || this.mateTitle === '无匹配项') {
          Modal.error({title: '请选择患者来源的匹配医生'})
          return false
        }
      }
      if (!this.patientName) {
        Modal.error({ title: '请填写患者姓名' })
        return false
      }
      if (!this.patientGender) {
        Modal.error({ title: '请选择患者性别' })
        return false
      }
      if (this.checkedBodyData.length === 0) {
        Modal.error({ title: '请选择检查部位' })
        return false
      }
      if (this.orderSource === '科研检查单') {
        if (this.mateTitle === '匹配' || this.mateTitle === '无匹配项') {
          Modal.error({title: '请选择患者来源的匹配医生'})
          return false
        }
      }
      if (this.from === 'addKzFlag' || this.from === 'editKzFlag' || this.isAppointmentCheck) {
        if (!this.service_appointment_datetime) {
          Modal.error({ title: '请选择预约时间' })
          return false
        }
        return true
      } else if (this.from === 'queue' || this.from === 'callNum' || this.from === 'historyCheck' || !this.from) {
        if (!this.patientBirthDay) {
          Modal.error({ title: '请填写生日' })
          return false
        }
        if (!this.patientAge) {
          Modal.error({ title: '请填写年龄' })
          return false
        }
        if (this.actualAmount === '') {
          Modal.error({ title: '请填写实际费用' })
          return false
        }
        if (!this.chargeChannel) {
          Modal.error({ title: '请选择收费渠道' })
          return false
        }
        if ((this.chargeChannel === '线上-微信' || this.chargeChannel === '线上-支付宝') && this.actualAmount.toString() === '0') {
          Modal.error({ title: '支付渠道为微信/支付宝修改实际费用不能为0！' })
          return false
        }
        if (!this.service_appointment_datetime) {
          Modal.error({ title: '请选择预约时间' })
          return false
        }
        return true
      }
    },
    // 对传入服务端的参数进行处理
    paramsHandler () {
      let checkArr = [] // 检查部位
      let afterHandleArr = [] // 后处理标签
      let materialCount = [] // 部位以及耗材
      let editSpecialRecord = {
        totalAmout: this.actualAmount,
        bodyDetailList: []
      }
      let isChangePrice = false
      if (this.checkOrderId) {
        if (this.actualAmount !== this.lastActualAmount) isChangePrice = true
      } else {
        if (this.actualAmount !== this.amount) isChangePrice = true
      }
      for (let i = 0; i < this.checkedBodyData.length; i++) {
        let item = this.checkedBodyData[i]
        let obj = { id: item.check_item_id, count: item.bodyNum }
        obj.chargeDiffDescription = { '医生特殊收费':item.doctorSpecialCharge, '增加扫描序列收费': item.addSeriesCharge,'替代未出胶片收费': item.extraFilmCharge }
        let materialInfo = filter(this.tableData, { check_item_id: item.check_item_id, type: 'material' }) || []
        materialInfo = cloneDeep(materialInfo)
        const noRepeatArr = uniqBy(materialInfo, 'materialId')
        const xorArr = xorWith(noRepeatArr, materialInfo, 'materialId');
        for (let j = 0; j < xorArr.length; j++) {
          const findItem = find(noRepeatArr, { materialId: xorArr[j]['materialId']})
          findItem.count = 1 * findItem.count + 1 * xorArr[j]['count']
        }
        obj.materialInfo = noRepeatArr
        checkArr.push(obj)
        if (isChangePrice) {
          const obj = {
            bodyItemName: item.body_item_name,
            doctorSpecialCharge: item.doctorSpecialCharge,
            addSeriesCharge: item.addSeriesCharge,
            extraFilmCharge: item.extraFilmCharge,
            conExCheckBodyAmount: item.conExCheckBodyAmount,
          }
          editSpecialRecord.bodyDetailList.push(obj)
        }
      }
      for (let i = 0; i < this.afterHandleList.length; i++) {
        let item = this.afterHandleList[i]
        let obj = { id: item.id, privateBaseElement: item.privateBaseElement }
        afterHandleArr.push(obj)
      }
      this.tableData.forEach(element => {
        if (element.type === 'material') {
          materialCount.push({ id: element.materialId, count: element.count })
        }
      })
      return { checkArr, afterHandleArr, materialCount, editSpecialRecord }
    },
    // 创建订单的参数
    orderParams () {
      let processParams = this.paramsHandler()
      const params = {
        patientName: this.patientName,
        patientGender: this.patientGender,
        patientBirthDay: this.patientBirthDay.format('YYYY-MM-DD'),
        patientAge: this.patientAge,
        ageUnit: this.ageUnit,
        outpatient_inpatient: this.outpatient_inpatient,
        emergency: this.emergency,
        medical_insurance: this.medical_insurance,
        materialCount: JSON.stringify(processParams.materialCount),
        orderSource: this.orderSource,
        medicalImageCenterDeviceId: this.curDeviceId,
        hospitalCheckItemIds: processParams.checkArr,
        itemCheckbaseElementIds: processParams.afterHandleArr,
        chargeChannel: this.chargeChannel,
        service_appointment_datetime: this.service_appointment_datetime,
        service_appointment_time: this.service_appointment_time,
        amount: this.amount,
        actualAmount: this.actualAmount,
        charge_share_type: this.charge_share_type
      }
      if (processParams.editSpecialRecord.bodyDetailList.length >= 1) params.priceRemark = JSON.stringify(processParams.editSpecialRecord)
      return params
    },
    // 创建该检查订单
    async handleSubmit () {
      this.submitLoading = true
      let params = this.orderParams()
      if (!this.outpatient_inpatient) {
        if (this.hospitalBed) params.hospitalBed = this.hospitalBed
        if (this.admissionNumber ) params.admissionNumber  = this.admissionNumber
      }
      if (this.patientIdNumber) params.patientIdNumber = this.patientIdNumber
      if (this.cardAddress) params.patientAddress = this.cardAddress
      if (this.patientMobile) params.patientMobile = this.patientMobile
      if (this.patientHeight) params.patientHeight = this.patientHeight
      if (this.patientWeight) params.patientWeight = this.patientWeight
      if (this.blood_pressure) params.blood_pressure = this.blood_pressure
      if (this.onlinePatientInfo) params.checkinId = this.onlinePatientInfo
      if (this.anamnesis) params.anamnesis = this.anamnesis
      if (this.isShowReport) params.report_required = this.report_required
      params.remark = this.remark.nurse || ''
      if (this.checkNumber) params.checkNumber = this.checkNumber
      if (this.bind_check_order_code) params.bind_check_order_code = this.bind_check_order_code
      if (this.doctorId) params.doctorId = this.doctorId
      if (this.orderCode) params.orderCode = this.orderCode
      if (this.checkOrderId) params.checkOrderId = this.checkOrderId
      if (this.from === 'addKzFlag' || this.from === 'editKzFlag' || this.isAppointmentCheck) params.onlineAgent = true
      if (this.waitingFlag) {
        if (this.remark.operation && this.signWaitOrder.reason === '其他') {
          params.online_agent_comment = this.remark.operation + '；' + this.signWaitOrder.otherReasonMsg
        } else if (this.remark.operation && this.signWaitOrder.reason !== '其他') {
          params.online_agent_comment = this.remark.operation + '；' + this.signWaitOrder.reason
        } else {
          params.online_agent_comment = this.signWaitOrder.reason
        }
        params.orderStatus = 5
      } else {
        params.online_agent_comment = this.remark.operation || ''
      }
      let data = await saveNewCheck(params)
      if (data) {
        toast({ title: '提示', duration: 1,  type: 'success', msg: '保存成功！' })
        if (!this.isAppointmentCheck && (this.paymentStatus !== 20 || (this.paymentStatus === 20 && this.oldChannel != '线上-微信' && this.oldChannel != '线上-支付宝'))) {
          if (this.currentCenterId == getAiCheckImageCenterId()) {
            return this.$router.replace({path: `/aiPay?checkOrderId=${data.id}&checkOrderParentId=${data.parent_id}`})
          } else {
            await makePayCode({ checkOrderId: data.id })
          }
        }
      }
      if (!data || !data.parent_id) return this.submitLoading = false
      if (this.from === 'addKzFlag' || this.from === 'editKzFlag' || this.isAppointmentCheck) {
        if (!this.waitingFlag) {
          let ask = await getTemplate({ orderCheckId: data.id})
          if (ask) {
            let year = ask.appointment_date.substring(0, 4)
            let month = ask.appointment_date.substring(5, 7)
            let day = ask.appointment_date.substring(8, 10)
            let time = ask.appointment_date.substring(11, 16)
            this.msgInfo = {
              patient_mobile: ask.tongxin_mobile,
              patient_name: ask.patient_name,
              hospital_name: ask.hospital_name,
              body_names: ask.body_names,
              year: year,
              month: month,
              day: day,
              time: time,
              hospital_address: ask.hospital_address,
              hospital_route: ask.hospital_route
            }
            this.submitLoading = false
            return this.sendMsg.openFlag = true
          }
        } else {
          this.submitLoading = false
          this.$router.back()
        }
      } else {
        if (this.relInformation.fileList.length > 0) {
          this.relInformation.checkOrderId = data.parent_id
          let uploadData = await this.uploadRelAction('addCheck')
          if (uploadData) {
            this.submitLoading = false
            this.$router.back()
          }
        } else {
          this.submitLoading = false
          this.$router.back()
        }
      }
    },
    // 匹配按钮
    matchDoctor () {
      if (this.$route.query.checkOrderId && this.isSettlementCheckStatus && this.isSettlementCheckStatus.toString() === '-1') {
        return toast({msg: `${this.settlement_check_status_name}已将该订单标为问题，暂无法匹配医生`, title: '提示', type: 'warning'})
      }
      const needMatchEnum = ['线下', '快诊', '科研检查单']
      if (needMatchEnum.includes(this.orderSource)) return this.showMatchDoctorModal = true
    },
    // 获取预约时间
    checkDateTime () {
      this.showCheckDate = true
      setTimeout(() => {
        this.$refs.check.getCheckData(this.currentCenterId, this.curDeviceId)
      }, 300)
    },
    // 关闭预约检查时间的弹框
    closeCheckModal () {
      this.showCheckDate = false
    },
    // 对获取的预约时间的格式进行处理
    getCheckDate (year, time) {
      this.service_appointment_datetime = year
      this.service_appointment_time = time
      this.checkText = year + ' ' + zeroPadding(time)
    },
    formatDoctorMateTitle (doctorId, doctorName) {
      const initials = getNameInitials(doctorName)
      if (doctorId && initials) return `${initials}_${doctorId}`
      if (doctorId) return `${doctorId}`
      return initials || '匹配'
    },
    // 无匹配医生
    noDoctorMate () {
      this.showMatchDoctorModal = false
      this.mateTitle = '无匹配项'
      this.doctorId = 0
      this.orderCode = 0
    },
    // 匹配到医生
    haveDoctorMate (doctor) {
      this.showMatchDoctorModal = false
      this.mateTitle = this.formatDoctorMateTitle(doctor.id, doctor.real_name)
      this.doctorId = doctor.id
      this.orderCode = 0
    },
    // 无匹配订单
    noOrderMate () {
      this.showMatchOrderList = false
      this.mateTitle = '无匹配项'
      this.doctorId = 0
      this.orderCode = 0
    },
    // 匹配到订单
    haveOrderMate (order) {
      this.showMatchOrderList = false
      this.mateTitle = order.order_code
      this.doctorId = 0
      this.orderCode = parseInt(order.order_code)
    },
    // 点击标为待定订单
    signWaitClick () {
      this.signWaitOrder.openFlag = true
      this.waitingFlag = true
    },
    // 确定标记待定
    async sureSignWaitOrder () {
      if (!this.signWaitOrder.reason) return toast({ title: '提示', type: 'warning', msg: '请您选择待定原因！' })
      if (this.signWaitOrder.reason === '其他' && !this.signWaitOrder.otherReasonMsg) return toast({ title: '提示', type: 'warning', msg: '请您填写待定原因！' })
      await this.handleSubmit()
    },
    // 点击取消订单
    cancelOrderClick () {
      this.cancelOrder.openFlag = true
    },
    // 确定取消订单
    async sureCancelOrder () {
      let data = await nurseCancelCheck({ id: this.checkOrderId, reason: '' })
      if (data) {
        toast({ title: '提示', type: 'success', msg: '取消订单成功！' })
        this.cancelOrder.openFlag = false
        this.$router.back()
      }
    },
    // 改变检查医院
    async changeCurrentHospital(data) {
      console.log('查看改变检查医院data:', data)
      this.setCurrentHospitalVal = data.hospital_medical_image_center_id
      let curCenter = null
      for (let i = 0; i < this.centerVos.length; i++) {
        let val = this.centerVos[i]
        if (val.id === data.hospital_medical_image_center_id) {
          curCenter = val
          break
        }
      }
      this.setCenter(curCenter)
      this.setCurrentCenter(curCenter)
      this.setCurDevice(data.device_id)
      // this.setCurDevice(this.deviceList[0].id)
      this.setCurDeviceVal = this.deviceList[0].id
      await this.getDeviceList()
    },
    // 改变检查设备
    async changeCurDevice (data) {
      this.setCurDeviceVal = data
      this.setCurDevice(data)
      await this.getDeviceList()
    },
    // 判断角色
    isRole (rcode) {
      if (!this.role || this.role.length <= 0) return false
      for (let i = 0; i < this.role.length; i++) {
        if (this.role[i].rcode === rcode) return true
      }
      return false
    },
    // 读取患者信息
    async getPatientInfo () {
      if (!this.patientMobile) return toast({ title: '提示', type: 'warning', msg: '请先填写患者手机号' })
      if (this.patientMobile && this.patientMobile.length < 11) return toast({ title: '提示', type: 'warning', msg: '您填写的手机号有误，请核对！' })
      let data = await getPatientMsgForPhone({ mobile: this.patientMobile })
      if (data) {
        this.patientHeight = data.height
        this.patientWeight = data.weight
        this.patientBirthDay = data.birth_date ? moment(data.birth_date) : moment()
        this.patientGender = data.gender.toString()
        this.patientName = data.real_name
        this.sendPatientId = data.id
        this.patientIdNumber = data.id_number
        if (data.patient_address) this.cardAddress = data.patientAddress
        this.setAgeUnit()
      }
    },
    handleCopyInfo () {
      let deviceName = ''
      this.deviceList.map((item) => {
        if (item.id === this.setCurDeviceVal) {
          deviceName = item.name
        }
      })
      let bodyArray = []
      this.checkedBodyData.map((item, index) => {
        bodyArray.push(`${index + 1}、${item.body_item_name}*${item.bodyNum}`)
      })
      this.showCopyInfo = true
      this.copyInfo = '患者姓名：' + this.patientName + '\n' + '患者电话：' + this.patientMobile + '\n' + '检查项目：' + deviceName + '\n' + '检查部位：' + bodyArray.toString('，') + '\n' + '麻烦老师安排一下！'
    },
    // 复制信息
    handleOnCopy () {
      this.showCopyInfo = false
      toast({ title: '提示', type: 'success', msg: '复制成功' })
    },
    closeCopyInfo () {
      this.showCopyInfo = false
    },
    // 短信模版
    handlePatientName (data) {
      if (!data) this.msgInfo.patient_name = ''
      this.msgInfo.patient_name = data
    },
    handleHospitalName (data) {
      if (!data) this.msgInfo.hospital_name = ''
      this.msgInfo.hospital_name = data
    },
    handleBodyNames (data) {
      if (!data) this.msgInfo.body_names = ''
      this.msgInfo.body_names = data
    },
    handleMonth (data) {
      if (!data) this.msgInfo.month = ''
      this.msgInfo.month = data
    },
    handleDay (data) {
      if (!data) this.msgInfo.day = ''
      this.msgInfo.day = data
    },
    handleTime (data) {
      if (!data) this.msgInfo.time = ''
      this.msgInfo.time = data
    },
    handleHospitalAddress (data) {
      if (!data) this.msgInfo.hospital_address = ''
      this.msgInfo.hospital_address = data
    },
    handleHospitalRoute (data) {
      if (!data) this.msgInfo.hospital_route = ''
      this.msgInfo.hospital_route = data
    },
    handleTongxinMobile (data) {
      if (!data) this.msgInfo.patient_mobile = ''
      this.msgInfo.patient_mobile = isSpace(data)
    },
    openUploadImageModal() {
      this.uploadImage.uploadImageModal = true
    },
    beforeUploadImage(file) {
      this.uploadImage.fileList.push(file)
      return false
    },
    deleteUploadFile(index){
      this.uploadImage.fileList.splice(index,1)
    },
    async uploadImageAction() {
      let fileList = this.uploadImage.fileList
      if (fileList.length < 1) return toast({msg: '请先选择正确的影像文件', title: '操作提示', type: 'error'})
      this.uploadImage.uploadPercent = 0
      this.uploadImage.uploadLoading = true
      for (let i = 0; i < fileList.length; i++) {
        let file = this.uploadImage.fileList[i]
        let data = await aiUploadImage({patientName: this.patientName, orderCheckCode: this.checkNumber, orderCheckId: this.checkOrderId, imageCenterId: this.currentCenterId, file: file})
        if (data) {
          setTimeout(() => {
            this.uploadImage.uploadPercent = (100 * (((i + 1) / fileList.length))).toFixed(0)
          }, 500)
        } else {
          toast({msg: `上传第${i + 1}个影像文件失败`, type: 'error'})
        }
      }
      this.uploadImage.uploadLoading = false
      let isComplete = await aiUploadImageComplete({id: this.checkNumber})
      if (isComplete) this.uploadImage.isComplete = true
    },
    closeUploadImage() {
      this.uploadImage.uploadImageModal = false
      this.uploadImage.fileList = []
      this.uploadImage.isComplete = false
    },
    openUploadOtherModal() {
      this.uploadOtherFile.uploadModal = true
    },
    beforeUploadOtherFile(file) {
      this.uploadOtherFile.fileList.push(file)
      return false
    },
    deleteUploadOtherFile(index){
      this.uploadOtherFile.fileList.splice(index,1)
    },
    async uploadOtherAction() {
      let fileList = this.uploadOtherFile.fileList
      if (fileList.length < 1) return toast({msg: '请先选择要上传的文件', title: '操作提示', type: 'error'})
      this.uploadOtherFile.uploadPercent = 0
      this.uploadOtherFile.uploadLoading = true
      for (let i = 0; i < fileList.length; i++) {
        let file = this.uploadOtherFile.fileList[i]
        let sliceInfo = await sliceFile(file, 2)
        let params = {
          id: this.checkOrderId,
          size: file.size,
          total: sliceInfo.sliceNum,
          fileMd5: sliceInfo.originFileMd5,
          name: file.name
        }
        let perProData = Math.floor(100 / sliceInfo.sliceNum)
        for(let i = 0; i < sliceInfo.sliceNum; i++) {
          let chunkItem = sliceInfo.chunkArr[i]
          params.file = chunkItem.file
          params.md5 = chunkItem.md5
          params.index = chunkItem.index
          params.action = 'check'
          let data = await checkUploadFile(params)
          if (!data)  {
            toast({msg: '分片上传文件检测异常，请重新上传', type: 'error', title: '错误提示'})
            this.uploadOtherFile.uploadLoading = false
            this.uploadOtherFile.uploadPercent = 0
            return false
          }
          params.action = 'addChunk'
          let uploadData = await checkUploadFile(params)
          if (!uploadData) {
            toast({msg: '分片上传文件异常，请重新上传', type: 'error', title: '错误提示'})
            this.uploadOtherFile.uploadLoading = false
            this.uploadOtherFile.uploadPercent = 0
            return false
          } else {
            this.uploadOtherFile.uploadPercent = ( 1 * this.uploadOtherFile.uploadPercent + perProData).toFixed(0)
          }
        }
      }
      toast({msg: '上传文件成功', title: '操作提示', type: 'success'})
      this.uploadOtherFile.uploadLoading = false
      this.uploadOtherFile.uploadModal = false
      this.uploadOtherFile.fileList = []
    },
    addExtraPrice(record) {
      if (!isNumber(record.doctorSpecialCharge)) record.doctorSpecialCharge = 0
      if (!isNumber(record.addSeriesCharge)) record.addSeriesCharge = 0
      if (!isNumber(record.extraFilmCharge)) record.extraFilmCharge = 0
      this.updatePerCheckedBodyAmount(record)
      this.computedTotalMoney()
    },
    async openSpecialEditRecrod () {
      let recordParams = { orderCheckId: this.checkOrderId, pageNumber: 1, pageSize: 100000, recordChangeLogTypeEnum: 'CHECK_ORDER_PRICE' }
      let data = await getChangePriceRecord(recordParams)
      if (data && isArray(data.results) && data.results.length >= 1) {
        this.editPriceRecord.list = data.results
        this.editPriceRecord.showModal = true
      } else {
        return toast({ msg: '暂无修改记录', title: '操作提示', type: 'warning'})
      }
    },
    watchEditPriceRecord (record) {
      this.showSpecialPriceRecord.recordObj = JSON.parse(record.remark)
      this.showSpecialPriceRecord.showModal = true
    },
    // 判断当前角色是否可以修改检查单
    judgeIsEidtCheckOrder () {
      const isSuperAdmin = this.isRole('ROLE_ROOT')
      const flag = this.isRole('ROLE_CHECK_ORDER_OPERATION_ADMINISTRATOR')
      if (isSuperAdmin || flag) {
        return false
      }
      if (this.isEditedOperation || this.checkOrderStatus.toString() === '50' ) {
        return true
      }
      return false
    }
  },
  watch: {
    // 根据当前所在的影像中心切换设备
    async currentCenterId (newVal, oldVal) {
      if (newVal === oldVal || !newVal) return false
      this.setCurrentHospitalVal =  newVal
      await this.getDeviceList()
      this.getCenterConsumData()
      this.equivalentCount = 0
      this.afterHandleList = []
      this.checkedBodyData = []
      this.amount = 0
      this.actualAmount = 0
      if (this.payType) {
        this.chargeChannel = this.payType
      } else {
        this.chargeChannel = ''
      }
      if (this.hospitalFlag.toString() === '1') {
        this.isShowReport = true
      } else {
        this.isShowReport = false
      }
      this.tableData = []
      this.checkText = '选择'
      this.remark = {
        doctor: '',
        operation: ''
      }
    }
  }
}
</script>

<style lang="less">
@import url('../../style/index.less');
  .addCheckPage{
    overflow-y: auto;
    height: 100%;
    .patientOriginSelect{
      .ant-select-selection{
        border-right: none;
        border-top-right-radius: unset;
        border-bottom-right-radius: unset;
      }
    }
    .matchButtonWrap{
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
      width: 100%;
      height:32px;
      margin-bottom:3px;
      border-left:none;
      border-bottom-left-radius: unset;
      border-top-left-radius:unset;
    }
    .ant-radio-button-wrapper{
      min-width: 59px;
      text-align: center;
    }
    .ant-card{
      padding-bottom: 0;
      overflow: hidden;
      .ant-card-body{
        height: 658px;
        padding: 0 @LeaveDistance  @LeaveDistance @LeaveDistance !important;
      }
    }
    .ant-input-suffix{
      right: 0;
    }
    .ant-form-item{
      margin-bottom: 4px;
    }
    .afterDealClass{
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
      width: 80px;
    }
    .checkItemWrap{
      margin-bottom: 16px;
      .choiceItem{
        border:1px solid #d9d9d9;
        height: 240px;
        padding: 5px 0;
        border-radius: 5px;
        overflow: auto;
        .bodyItemName{
          border: 1px solid #1890ff;
          border-radius: 10px;
          padding:5px 0;
          padding-left: 5px;
        }
      }
      .choiceItemleft{
        margin-right: 5px;
        padding-left: 5px;
        .ant-btn{
          margin-left: 0!important;
          margin-right: 16px;
        }
      }
      .handeleInputStyle{
        overflow-y: auto;
        .ant-table-small{
          border: 0;
        }
        .ant-input-number{
          width: 45px;
        }
      }
    }
    .consumablesWrap{
      .consumablesTable{
        height: 242px;
        overflow-y: auto;
      }
      margin:16px 0;
      .remarksCon{
        margin-top: 10px;
        display: flex;
        justify-content: space-around;
        .doctorNote{
          flex: 1;
          display: flex;
          justify-content: flex-start;
          .remarksMsg{
            flex: 5;
          }
          .remarksTitle{
            flex: 1;
          }
          margin-right: 16px;
        }
        .operationNote{
          flex: 1;
          display: flex;
          justify-content: flex-start;
          .remarksMsg{
            flex: 5;
          }
          .remarksTitle{
            flex: 1;
          }
        }
      }
    }
    .buttonWrap{
      background: #fff;
      padding: 16px 32px;
      display: flex;
      flex-direction: row-reverse;
      .operationControl{
        flex: 1;
      }
    }
    .aiHiddenItem{
      display: none;
    }
  }
  .addCheckPage{
    .addHeight{
      height: 750px !important;
    }
  }
  // 上传资料样式
  .uploadWrap{
    display: flex;
    .showWrap{
      .showArea{
        width: 400px;
        height: 400px;
        margin-right: 10px;
      }
      .operatonWrap{
        margin-top: 10px;
      }
    }
    .imageList{
      overflow: hidden;
      .imageItem{
        position:relative;
        width:104px;
        height:104px;
        float:left;
        margin: 0 8px 8px 0;
        border: 1px solid #d9d9d9;
        border-radius:4px;
        padding: 8px;
        img{
          width:86px;
          height:86px;
          object-fit:cover;
          position:relative;
          z-index:1;
        }
        .actionWrap{
          position:absolute;
          z-index:100;
          top:8px;
          left:8px;
          right:8px;
          bottom:8px;
          display:flex;
          align-items:center;
          justify-content: center;
          background-color:#333;
          color: #fff;
          opacity: 0.6;
        }
      }
    }
  }
  .sendMsgModal{
    p{
      line-height: 35px;
    }
  }
  // 上传影像样式
  .uploadImageWrap{
    height: 300px;
    .ant-upload{
      display: table;
      width: 100%;
      padding: 0;
      text-align: center;
      padding: 0 !important;
    }
    .ant-upload.ant-upload-drag .ant-upload-drag-container{
      width: 100%;
      height: 300px;
      text-align: center;
    }
    .fileList{
      border: 1px dashed #d9d9d9;
      height:100%;
      overflow:auto;
      .fileItem{
        display:inline-block;
        border: 1px solid #e8e8e8;
        padding: 7px 5px;
        margin: 15px 5px 0 10px;
        position: relative;
        .anticon-close-circle{
          position: absolute;
          top: -9px;
          font-size: 20px;
          right: -10px;
          cursor: pointer;
          z-index: 100;
        }
      }
    }
  }
  .watchSlideRelevantInfo();
  .editPriceListModal{
    .editPriceTable{
      width: 100%;
      border-collapse: collapse;
      td, th{
        border: 1px solid #eee;
        padding: 10px;
      }
      th{
        background: #fafafa;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 500;
      }
    }
  }
  .checkTimeModal{
    .ant-modal-body{
      min-height: 554px;
    }
  }
  // 兼容手机端
  @media screen and (max-width: 991px) {
    .addCheckPage{
      .firstCol{
        .ant-card {
          .ant-card-body{
            height: auto !important;
            padding: 5px 16px !important;
            border: none;
          }
          .ant-col-xs-4{
            margin-top: 10px;
          }
        }
      }
    }
    .ant-form-inline .ant-form-item{
      margin-right: 0;
    }
    .consumablesTable{
      height: auto;
    }
    .bodyInfoWrap{
      background-color: #fff;
      .ant-card-body{
        border:none;
        height: 100% !important;
      }
      .deviceWrap, .checkObject{
        .ant-form-item{
          display: flex;
          align-items: center;
          .ant-form-item-label{
            width: auto !important;
          }
          .ant-form-item-control-wrapper{
            margin-left: 10px;
            flex:1;
            .ant-select, .ant-input{
              width: 100% !important;
            }
          }
        }
      }
      .checkItemWrap, .consumablesWrap{
        .ant-row{
          .ant-col-16, .ant-col-8{
            width: 100%;
          }
        }
      }
      .consumablesWrap{
        .remarksCon{
          flex-direction: column;
          .doctorNote, .operationNote{
            margin-bottom: 10px;
          }
        }
      }
    }
    .buttonWrap{
      display: block !important;
      padding: 16px 16px !important;
      .cancelBtn, .saveBtn{
        display: block;
        width: 100%;
        margin-bottom: 10px;
      }
      .operationControl{
        display: block !important;
        button{
          width: 100%;
          margin-bottom: 10px;
          margin-left: 0 !important;
        }
      }
    }
    .checkTimeModal{
      top: 20px;
    }
  }
</style>
